import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export var AddAdditionalInterestBlockReason;
(function (AddAdditionalInterestBlockReason) {
    AddAdditionalInterestBlockReason["ActiveEndorsement"] = "ActiveEndorsement";
    AddAdditionalInterestBlockReason["ActiveRenewal"] = "ActiveRenewal";
    AddAdditionalInterestBlockReason["NonRenewalIssued"] = "NonRenewalIssued";
    AddAdditionalInterestBlockReason["PolicyCancelled"] = "PolicyCancelled";
    AddAdditionalInterestBlockReason["PolicyExpired"] = "PolicyExpired";
    AddAdditionalInterestBlockReason["WebAppApiRequestFailed"] = "WebAppApiRequestFailed";
    AddAdditionalInterestBlockReason["WebAppApiRequestNotValid"] = "WebAppApiRequestNotValid";
})(AddAdditionalInterestBlockReason || (AddAdditionalInterestBlockReason = {}));
export var AdditionalInterestType;
(function (AdditionalInterestType) {
    AdditionalInterestType["GovernmentMunicipality"] = "GovernmentMunicipality";
    AdditionalInterestType["HomeownersAssociation"] = "HomeownersAssociation";
    AdditionalInterestType["Lienholder"] = "Lienholder";
    AdditionalInterestType["NotListed"] = "NotListed";
    AdditionalInterestType["PropertyManagerParkOwner"] = "PropertyManagerParkOwner";
})(AdditionalInterestType || (AdditionalInterestType = {}));
export var AdditionalInterestValidationBlockReason;
(function (AdditionalInterestValidationBlockReason) {
    AdditionalInterestValidationBlockReason["ActiveEndorsement"] = "ActiveEndorsement";
    AdditionalInterestValidationBlockReason["ActiveRenewal"] = "ActiveRenewal";
    AdditionalInterestValidationBlockReason["NonRenewalIssued"] = "NonRenewalIssued";
    AdditionalInterestValidationBlockReason["PolicyCancelled"] = "PolicyCancelled";
    AdditionalInterestValidationBlockReason["PolicyExpired"] = "PolicyExpired";
})(AdditionalInterestValidationBlockReason || (AdditionalInterestValidationBlockReason = {}));
export var AllOtherPerilsDeductible;
(function (AllOtherPerilsDeductible) {
    AllOtherPerilsDeductible["Dollars1K"] = "Dollars1K";
    AllOtherPerilsDeductible["Dollars2K500"] = "Dollars2K500";
    AllOtherPerilsDeductible["Dollars5K"] = "Dollars5K";
    AllOtherPerilsDeductible["Dollars10K"] = "Dollars10K";
    AllOtherPerilsDeductible["Dollars500"] = "Dollars500";
})(AllOtherPerilsDeductible || (AllOtherPerilsDeductible = {}));
export var BurglarAlarmValue;
(function (BurglarAlarmValue) {
    BurglarAlarmValue["Local"] = "Local";
    BurglarAlarmValue["Monitored"] = "Monitored";
    BurglarAlarmValue["No"] = "No";
})(BurglarAlarmValue || (BurglarAlarmValue = {}));
export var CanOperateInStateResult;
(function (CanOperateInStateResult) {
    CanOperateInStateResult["MissingLicense"] = "MissingLicense";
    CanOperateInStateResult["NotAppointedInNonJitState"] = "NotAppointedInNonJITState";
    CanOperateInStateResult["NotRequestedInNonJitState"] = "NotRequestedInNonJITState";
    CanOperateInStateResult["RejectedInJitState"] = "RejectedInJITState";
    CanOperateInStateResult["UnsupportedState"] = "UnsupportedState";
    CanOperateInStateResult["Yes"] = "Yes";
})(CanOperateInStateResult || (CanOperateInStateResult = {}));
export var CoverageAnimalLiabilityValue;
(function (CoverageAnimalLiabilityValue) {
    CoverageAnimalLiabilityValue["Dollars10K"] = "Dollars10K";
    CoverageAnimalLiabilityValue["Dollars25K"] = "Dollars25K";
    CoverageAnimalLiabilityValue["Dollars50K"] = "Dollars50K";
    CoverageAnimalLiabilityValue["Dollars100K"] = "Dollars100K";
    CoverageAnimalLiabilityValue["Dollars300K"] = "Dollars300K";
    CoverageAnimalLiabilityValue["Dollars500K"] = "Dollars500K";
    CoverageAnimalLiabilityValue["Excluded"] = "Excluded";
})(CoverageAnimalLiabilityValue || (CoverageAnimalLiabilityValue = {}));
export var CoverageDLossOfUseValue;
(function (CoverageDLossOfUseValue) {
    CoverageDLossOfUseValue["Percent10"] = "Percent10";
    CoverageDLossOfUseValue["Percent20"] = "Percent20";
    CoverageDLossOfUseValue["Percent30"] = "Percent30";
    CoverageDLossOfUseValue["Percent40"] = "Percent40";
})(CoverageDLossOfUseValue || (CoverageDLossOfUseValue = {}));
export var CoverageDamageToPropertyOfOthersValue;
(function (CoverageDamageToPropertyOfOthersValue) {
    CoverageDamageToPropertyOfOthersValue["Dollars500"] = "Dollars500";
})(CoverageDamageToPropertyOfOthersValue || (CoverageDamageToPropertyOfOthersValue = {}));
export var CoverageDebrisRemovalValue;
(function (CoverageDebrisRemovalValue) {
    CoverageDebrisRemovalValue["Dollars5K"] = "Dollars5K";
    CoverageDebrisRemovalValue["Dollars10K"] = "Dollars10K";
})(CoverageDebrisRemovalValue || (CoverageDebrisRemovalValue = {}));
export var CoverageELiabilityValue;
(function (CoverageELiabilityValue) {
    CoverageELiabilityValue["Dollars25K"] = "Dollars25K";
    CoverageELiabilityValue["Dollars50K"] = "Dollars50K";
    CoverageELiabilityValue["Dollars100K"] = "Dollars100K";
    CoverageELiabilityValue["Dollars300K"] = "Dollars300K";
    CoverageELiabilityValue["Dollars500K"] = "Dollars500K";
})(CoverageELiabilityValue || (CoverageELiabilityValue = {}));
export var CoverageEarthquakeValue;
(function (CoverageEarthquakeValue) {
    CoverageEarthquakeValue["Percent10"] = "Percent10";
    CoverageEarthquakeValue["Percent15"] = "Percent15";
    CoverageEarthquakeValue["Percent20"] = "Percent20";
})(CoverageEarthquakeValue || (CoverageEarthquakeValue = {}));
export var CoverageEquipmentBreakdownValue;
(function (CoverageEquipmentBreakdownValue) {
    CoverageEquipmentBreakdownValue["Dollars100K"] = "Dollars100K";
})(CoverageEquipmentBreakdownValue || (CoverageEquipmentBreakdownValue = {}));
export var CoverageFMedicalPaymentToOthersValue;
(function (CoverageFMedicalPaymentToOthersValue) {
    CoverageFMedicalPaymentToOthersValue["Dollars1K"] = "Dollars1K";
    CoverageFMedicalPaymentToOthersValue["Dollars2K"] = "Dollars2K";
    CoverageFMedicalPaymentToOthersValue["Dollars3K"] = "Dollars3K";
    CoverageFMedicalPaymentToOthersValue["Dollars4K"] = "Dollars4K";
    CoverageFMedicalPaymentToOthersValue["Dollars5K"] = "Dollars5K";
    CoverageFMedicalPaymentToOthersValue["Dollars500"] = "Dollars500";
})(CoverageFMedicalPaymentToOthersValue || (CoverageFMedicalPaymentToOthersValue = {}));
export var CoverageFungiWetOrDryRotOrBacteriaPropertyValue;
(function (CoverageFungiWetOrDryRotOrBacteriaPropertyValue) {
    CoverageFungiWetOrDryRotOrBacteriaPropertyValue["Dollars3K500"] = "Dollars3K500";
})(CoverageFungiWetOrDryRotOrBacteriaPropertyValue || (CoverageFungiWetOrDryRotOrBacteriaPropertyValue = {}));
export var CoverageGolfCartValue;
(function (CoverageGolfCartValue) {
    CoverageGolfCartValue["Five"] = "Five";
    CoverageGolfCartValue["Four"] = "Four";
    CoverageGolfCartValue["One"] = "One";
    CoverageGolfCartValue["Three"] = "Three";
    CoverageGolfCartValue["Two"] = "Two";
})(CoverageGolfCartValue || (CoverageGolfCartValue = {}));
export var CoverageIdentityFraudExpenseValue;
(function (CoverageIdentityFraudExpenseValue) {
    CoverageIdentityFraudExpenseValue["Dollars15K"] = "Dollars15K";
})(CoverageIdentityFraudExpenseValue || (CoverageIdentityFraudExpenseValue = {}));
export var CoverageInflationGuardValue;
(function (CoverageInflationGuardValue) {
    CoverageInflationGuardValue["Percent3"] = "Percent3";
})(CoverageInflationGuardValue || (CoverageInflationGuardValue = {}));
export var CoverageLossAssessmentValue;
(function (CoverageLossAssessmentValue) {
    CoverageLossAssessmentValue["Dollars1K"] = "Dollars1K";
    CoverageLossAssessmentValue["Dollars5K"] = "Dollars5K";
})(CoverageLossAssessmentValue || (CoverageLossAssessmentValue = {}));
export var CoverageWaterBackupAndSumpOverflowValue;
(function (CoverageWaterBackupAndSumpOverflowValue) {
    CoverageWaterBackupAndSumpOverflowValue["Dollars5K"] = "Dollars5K";
    CoverageWaterBackupAndSumpOverflowValue["Dollars10K"] = "Dollars10K";
    CoverageWaterBackupAndSumpOverflowValue["Dollars25K"] = "Dollars25K";
})(CoverageWaterBackupAndSumpOverflowValue || (CoverageWaterBackupAndSumpOverflowValue = {}));
export var CoverageWaterDamageValue;
(function (CoverageWaterDamageValue) {
    CoverageWaterDamageValue["FullCoverage"] = "FullCoverage";
    CoverageWaterDamageValue["Percent10"] = "Percent10";
    CoverageWaterDamageValue["Percent25"] = "Percent25";
    CoverageWaterDamageValue["Percent50"] = "Percent50";
})(CoverageWaterDamageValue || (CoverageWaterDamageValue = {}));
export var CoveredOptionName;
(function (CoveredOptionName) {
    CoveredOptionName["AircraftAndMotorVehiclesCollision"] = "AircraftAndMotorVehiclesCollision";
    CoveredOptionName["BadWeather"] = "BadWeather";
    CoveredOptionName["BurglaryTheftVandalism"] = "BurglaryTheftVandalism";
    CoveredOptionName["Earthquake"] = "Earthquake";
    CoveredOptionName["Electronics"] = "Electronics";
    CoveredOptionName["FireSmokeAndExplosion"] = "FireSmokeAndExplosion";
    CoveredOptionName["Flood"] = "Flood";
    CoveredOptionName["Lawsuits"] = "Lawsuits";
    CoveredOptionName["NeglectAndIntentionalLoss"] = "NeglectAndIntentionalLoss";
    CoveredOptionName["OrdinanceOrLaw"] = "OrdinanceOrLaw";
    CoveredOptionName["PowerFailure"] = "PowerFailure";
    CoveredOptionName["Precipitation"] = "Precipitation";
    CoveredOptionName["RiotCivilCommotion"] = "RiotCivilCommotion";
    CoveredOptionName["ToolsAndEquipment"] = "ToolsAndEquipment";
    CoveredOptionName["Valuables"] = "Valuables";
    CoveredOptionName["VandalismAndTheft"] = "VandalismAndTheft";
    CoveredOptionName["WarAndNuclearHazard"] = "WarAndNuclearHazard";
    CoveredOptionName["WaterDamage"] = "WaterDamage";
})(CoveredOptionName || (CoveredOptionName = {}));
export var CreateOrUpdateEndorsementBlockReason;
(function (CreateOrUpdateEndorsementBlockReason) {
    CreateOrUpdateEndorsementBlockReason["ActiveEndorsement"] = "ActiveEndorsement";
    CreateOrUpdateEndorsementBlockReason["ActiveRenewal"] = "ActiveRenewal";
    CreateOrUpdateEndorsementBlockReason["EndorsementNotFound"] = "EndorsementNotFound";
    CreateOrUpdateEndorsementBlockReason["IneligibleRisk"] = "IneligibleRisk";
    CreateOrUpdateEndorsementBlockReason["NonRenewalIssued"] = "NonRenewalIssued";
    CreateOrUpdateEndorsementBlockReason["PolicyCancelled"] = "PolicyCancelled";
    CreateOrUpdateEndorsementBlockReason["PolicyCloseExpiration"] = "PolicyCloseExpiration";
    CreateOrUpdateEndorsementBlockReason["PolicyExpired"] = "PolicyExpired";
    CreateOrUpdateEndorsementBlockReason["SocotraRequestFailed"] = "SocotraRequestFailed";
})(CreateOrUpdateEndorsementBlockReason || (CreateOrUpdateEndorsementBlockReason = {}));
export var EditOrReplaceAdditionalInterestBlockReason;
(function (EditOrReplaceAdditionalInterestBlockReason) {
    EditOrReplaceAdditionalInterestBlockReason["ActiveEndorsement"] = "ActiveEndorsement";
    EditOrReplaceAdditionalInterestBlockReason["ActiveRenewal"] = "ActiveRenewal";
    EditOrReplaceAdditionalInterestBlockReason["NonRenewalIssued"] = "NonRenewalIssued";
    EditOrReplaceAdditionalInterestBlockReason["PolicyCancelled"] = "PolicyCancelled";
    EditOrReplaceAdditionalInterestBlockReason["PolicyExpired"] = "PolicyExpired";
    EditOrReplaceAdditionalInterestBlockReason["WebAppApiRequestFailed"] = "WebAppApiRequestFailed";
    EditOrReplaceAdditionalInterestBlockReason["WebAppApiRequestNotValid"] = "WebAppApiRequestNotValid";
})(EditOrReplaceAdditionalInterestBlockReason || (EditOrReplaceAdditionalInterestBlockReason = {}));
export var EditOrReplaceOperationType;
(function (EditOrReplaceOperationType) {
    EditOrReplaceOperationType["Edit"] = "Edit";
})(EditOrReplaceOperationType || (EditOrReplaceOperationType = {}));
export var EndorsementEligibilityBlockReason;
(function (EndorsementEligibilityBlockReason) {
    EndorsementEligibilityBlockReason["ActiveRenewal"] = "ActiveRenewal";
    EndorsementEligibilityBlockReason["NonRenewalIssued"] = "NonRenewalIssued";
    EndorsementEligibilityBlockReason["PolicyCancelled"] = "PolicyCancelled";
    EndorsementEligibilityBlockReason["PolicyCloseExpiration"] = "PolicyCloseExpiration";
    EndorsementEligibilityBlockReason["PolicyExpired"] = "PolicyExpired";
})(EndorsementEligibilityBlockReason || (EndorsementEligibilityBlockReason = {}));
export var EndorsementFailureReason;
(function (EndorsementFailureReason) {
    EndorsementFailureReason["ActiveRenewal"] = "ActiveRenewal";
    EndorsementFailureReason["ConflictingEndorsement"] = "ConflictingEndorsement";
    EndorsementFailureReason["DraftRenewal"] = "DraftRenewal";
    EndorsementFailureReason["ErrorOccurred"] = "ErrorOccurred";
    EndorsementFailureReason["InvalidState"] = "InvalidState";
    EndorsementFailureReason["IssuanceFailed"] = "IssuanceFailed";
    EndorsementFailureReason["NonRenewalIssued"] = "NonRenewalIssued";
    EndorsementFailureReason["PaymentFailed"] = "PaymentFailed";
    EndorsementFailureReason["PolicyCancelled"] = "PolicyCancelled";
    EndorsementFailureReason["PolicyExpired"] = "PolicyExpired";
    EndorsementFailureReason["UnderwritingDeclined"] = "UnderwritingDeclined";
    EndorsementFailureReason["UnderwritingReferred"] = "UnderwritingReferred";
})(EndorsementFailureReason || (EndorsementFailureReason = {}));
export var EndorsementStatus;
(function (EndorsementStatus) {
    EndorsementStatus["AwaitingApproval"] = "AwaitingApproval";
    EndorsementStatus["Discarded"] = "Discarded";
    EndorsementStatus["ErrorOccurred"] = "ErrorOccurred";
    EndorsementStatus["InProgress"] = "InProgress";
    EndorsementStatus["IssuanceFailed"] = "IssuanceFailed";
    EndorsementStatus["Issued"] = "Issued";
    EndorsementStatus["PaymentFailed"] = "PaymentFailed";
    EndorsementStatus["ReadyToIssue"] = "ReadyToIssue";
})(EndorsementStatus || (EndorsementStatus = {}));
export var EndorsementUnderwritingDecision;
(function (EndorsementUnderwritingDecision) {
    EndorsementUnderwritingDecision["Accepted"] = "Accepted";
    EndorsementUnderwritingDecision["Declined"] = "Declined";
    EndorsementUnderwritingDecision["Referred"] = "Referred";
})(EndorsementUnderwritingDecision || (EndorsementUnderwritingDecision = {}));
export var EsignReminderStatus;
(function (EsignReminderStatus) {
    EsignReminderStatus["Failed"] = "Failed";
    EsignReminderStatus["Success"] = "Success";
})(EsignReminderStatus || (EsignReminderStatus = {}));
export var FieldType;
(function (FieldType) {
    FieldType["Dropdown"] = "Dropdown";
    FieldType["Slider"] = "Slider";
    FieldType["Toggle"] = "Toggle";
})(FieldType || (FieldType = {}));
export var GetOverviewMetricsPeriod;
(function (GetOverviewMetricsPeriod) {
    GetOverviewMetricsPeriod["All"] = "All";
    GetOverviewMetricsPeriod["Month"] = "Month";
    GetOverviewMetricsPeriod["Today"] = "Today";
    GetOverviewMetricsPeriod["Week"] = "Week";
    GetOverviewMetricsPeriod["Year"] = "Year";
})(GetOverviewMetricsPeriod || (GetOverviewMetricsPeriod = {}));
export var GetQuoteFilterByStatus;
(function (GetQuoteFilterByStatus) {
    GetQuoteFilterByStatus["Expired"] = "Expired";
    GetQuoteFilterByStatus["Pending"] = "Pending";
    GetQuoteFilterByStatus["Valid"] = "Valid";
})(GetQuoteFilterByStatus || (GetQuoteFilterByStatus = {}));
export var HomeFixtures;
(function (HomeFixtures) {
    HomeFixtures["AFewExtras"] = "AFewExtras";
    HomeFixtures["Standard"] = "Standard";
    HomeFixtures["TopOfTheLine"] = "TopOfTheLine";
})(HomeFixtures || (HomeFixtures = {}));
export var HomeType;
(function (HomeType) {
    HomeType["AccessoryDwellingUnit"] = "AccessoryDwellingUnit";
    HomeType["CrossMod"] = "CrossMod";
    HomeType["DoubleWide"] = "DoubleWide";
    HomeType["Duplex"] = "Duplex";
    HomeType["Modular"] = "Modular";
    HomeType["ParkModel"] = "ParkModel";
    HomeType["SelfStorageSecured"] = "SelfStorageSecured";
    HomeType["SelfStorageUnSecured"] = "SelfStorageUnSecured";
    HomeType["SingleWide"] = "SingleWide";
    HomeType["StationaryTravelTrailer"] = "StationaryTravelTrailer";
    HomeType["TinyHome"] = "TinyHome";
    HomeType["TripleWide"] = "TripleWide";
    HomeType["Unknown"] = "Unknown";
})(HomeType || (HomeType = {}));
export var IbhsFortifiedCertification;
(function (IbhsFortifiedCertification) {
    IbhsFortifiedCertification["Bronze"] = "Bronze";
    IbhsFortifiedCertification["Gold"] = "Gold";
    IbhsFortifiedCertification["No"] = "No";
    IbhsFortifiedCertification["SaferLiving"] = "SaferLiving";
    IbhsFortifiedCertification["Silver"] = "Silver";
})(IbhsFortifiedCertification || (IbhsFortifiedCertification = {}));
export var OccupationType;
(function (OccupationType) {
    OccupationType["Accountant"] = "Accountant";
    OccupationType["ArtistDesigner"] = "ArtistDesigner";
    OccupationType["BusinessOwner"] = "BusinessOwner";
    OccupationType["ConstructionWorker"] = "ConstructionWorker";
    OccupationType["CustomerService"] = "CustomerService";
    OccupationType["DoctorNurse"] = "DoctorNurse";
    OccupationType["Driver"] = "Driver";
    OccupationType["EducatorTeacher"] = "EducatorTeacher";
    OccupationType["Engineer"] = "Engineer";
    OccupationType["ExecutiveManager"] = "ExecutiveManager";
    OccupationType["FinancialAnalyst"] = "FinancialAnalyst";
    OccupationType["HealthcareWorker"] = "HealthcareWorker";
    OccupationType["ItSoftwareProfessional"] = "ITSoftwareProfessional";
    OccupationType["Lawyer"] = "Lawyer";
    OccupationType["MarketingSales"] = "MarketingSales";
    OccupationType["MechanicTechnician"] = "MechanicTechnician";
    OccupationType["Military"] = "Military";
    OccupationType["PoliceFirefighter"] = "PoliceFirefighter";
    OccupationType["RealEstateAgent"] = "RealEstateAgent";
    OccupationType["RetailWorker"] = "RetailWorker";
    OccupationType["ScientistResearcher"] = "ScientistResearcher";
    OccupationType["Student"] = "Student";
    OccupationType["Unemployed"] = "Unemployed";
    OccupationType["WriterEditor"] = "WriterEditor";
})(OccupationType || (OccupationType = {}));
export var Operator;
(function (Operator) {
    Operator["Equal"] = "Equal";
    Operator["LessThanOrEqual"] = "LessThanOrEqual";
    Operator["MoreThanOrEqual"] = "MoreThanOrEqual";
})(Operator || (Operator = {}));
export var OrganizationRelationshipType;
(function (OrganizationRelationshipType) {
    OrganizationRelationshipType["Officer"] = "Officer";
    OrganizationRelationshipType["Other"] = "Other";
    OrganizationRelationshipType["Owner"] = "Owner";
    OrganizationRelationshipType["Partner"] = "Partner";
    OrganizationRelationshipType["Trustee"] = "Trustee";
})(OrganizationRelationshipType || (OrganizationRelationshipType = {}));
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["Corporation"] = "Corporation";
    OrganizationType["Estate"] = "Estate";
    OrganizationType["Llc"] = "LLC";
    OrganizationType["Llp"] = "LLP";
    OrganizationType["NotListed"] = "NotListed";
    OrganizationType["Partnership"] = "Partnership";
    OrganizationType["Trust"] = "Trust";
})(OrganizationType || (OrganizationType = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["BankAccount"] = "BankAccount";
    PaymentMethod["CreditDebitCard"] = "CreditDebitCard";
    PaymentMethod["MortgageBill"] = "MortgageBill";
})(PaymentMethod || (PaymentMethod = {}));
export var PaymentSchedule;
(function (PaymentSchedule) {
    PaymentSchedule["ElevenPay"] = "ElevenPay";
    PaymentSchedule["FullPay"] = "FullPay";
    PaymentSchedule["MortgageBill"] = "MortgageBill";
    PaymentSchedule["TwoPay"] = "TwoPay";
})(PaymentSchedule || (PaymentSchedule = {}));
export var PendingCancellationPolicyFilterByStatus;
(function (PendingCancellationPolicyFilterByStatus) {
    PendingCancellationPolicyFilterByStatus["All"] = "All";
    PendingCancellationPolicyFilterByStatus["EsignRequired"] = "EsignRequired";
    PendingCancellationPolicyFilterByStatus["Inspection"] = "Inspection";
    PendingCancellationPolicyFilterByStatus["NonPay"] = "NonPay";
    PendingCancellationPolicyFilterByStatus["Other"] = "Other";
})(PendingCancellationPolicyFilterByStatus || (PendingCancellationPolicyFilterByStatus = {}));
export var PersonalPropertyType;
(function (PersonalPropertyType) {
    PersonalPropertyType["AllOther"] = "AllOther";
    PersonalPropertyType["Bikes"] = "Bikes";
    PersonalPropertyType["CameraRecorderMedia"] = "CameraRecorderMedia";
    PersonalPropertyType["ComputerEquipment"] = "ComputerEquipment";
    PersonalPropertyType["FineArts"] = "FineArts";
    PersonalPropertyType["Furs"] = "Furs";
    PersonalPropertyType["GolfersEquipment"] = "GolfersEquipment";
    PersonalPropertyType["GunsAndAmmunition"] = "GunsAndAmmunition";
    PersonalPropertyType["Jewelry"] = "Jewelry";
    PersonalPropertyType["MusicalInstruments"] = "MusicalInstruments";
    PersonalPropertyType["RareAndCurrentCoins"] = "RareAndCurrentCoins";
    PersonalPropertyType["Silverware"] = "Silverware";
    PersonalPropertyType["StampsBooks"] = "StampsBooks";
    PersonalPropertyType["Tools"] = "Tools";
})(PersonalPropertyType || (PersonalPropertyType = {}));
export var PolicyFilterByStatus;
(function (PolicyFilterByStatus) {
    PolicyFilterByStatus["Active"] = "Active";
    PolicyFilterByStatus["All"] = "All";
    PolicyFilterByStatus["Cancelled"] = "Cancelled";
    PolicyFilterByStatus["Expired"] = "Expired";
    PolicyFilterByStatus["PendingESign"] = "PendingESign";
})(PolicyFilterByStatus || (PolicyFilterByStatus = {}));
export var PolicyListItemsSortBy;
(function (PolicyListItemsSortBy) {
    PolicyListItemsSortBy["CancellationEffectiveTimestamp"] = "CancellationEffectiveTimestamp";
    PolicyListItemsSortBy["CreatedTimestamp"] = "CreatedTimestamp";
    PolicyListItemsSortBy["EffectiveDate"] = "EffectiveDate";
    PolicyListItemsSortBy["IssuedDate"] = "IssuedDate";
    PolicyListItemsSortBy["Premium"] = "Premium";
})(PolicyListItemsSortBy || (PolicyListItemsSortBy = {}));
export var PolicyPlan;
(function (PolicyPlan) {
    PolicyPlan["CoverTree"] = "CoverTree";
    PolicyPlan["Gold"] = "Gold";
    PolicyPlan["Platinum"] = "Platinum";
    PolicyPlan["Silver"] = "Silver";
})(PolicyPlan || (PolicyPlan = {}));
export var PolicyStatus;
(function (PolicyStatus) {
    PolicyStatus["Activated"] = "Activated";
    PolicyStatus["Cancelled"] = "Cancelled";
    PolicyStatus["Expired"] = "Expired";
    PolicyStatus["InitialQuote"] = "InitialQuote";
    PolicyStatus["PendingCancellation"] = "PendingCancellation";
    PolicyStatus["PendingCancellationEsignRequired"] = "PendingCancellationEsignRequired";
    PolicyStatus["PendingCancellationInspection"] = "PendingCancellationInspection";
    PolicyStatus["PendingCancellationNonPay"] = "PendingCancellationNonPay";
    PolicyStatus["PendingCancellationOther"] = "PendingCancellationOther";
    PolicyStatus["PendingEsignRequired"] = "PendingEsignRequired";
})(PolicyStatus || (PolicyStatus = {}));
export var PolicyStep;
(function (PolicyStep) {
    PolicyStep["Checkout"] = "Checkout";
    PolicyStep["ClaimsCheck"] = "ClaimsCheck";
    PolicyStep["ExtraCoverages"] = "ExtraCoverages";
    PolicyStep["HomeDetails"] = "HomeDetails";
    PolicyStep["HomeOptions"] = "HomeOptions";
    PolicyStep["PersonalDetails"] = "PersonalDetails";
    PolicyStep["PersonalizedPlans"] = "PersonalizedPlans";
    PolicyStep["PolicyDetails"] = "PolicyDetails";
    PolicyStep["PolicySummary"] = "PolicySummary";
    PolicyStep["UnderwritingQuestions"] = "UnderwritingQuestions";
})(PolicyStep || (PolicyStep = {}));
export var PolicyUsage;
(function (PolicyUsage) {
    PolicyUsage["Owner"] = "Owner";
    PolicyUsage["Rental"] = "Rental";
    PolicyUsage["Seasonal"] = "Seasonal";
    PolicyUsage["Tenant"] = "Tenant";
    PolicyUsage["Vacant"] = "Vacant";
})(PolicyUsage || (PolicyUsage = {}));
export var PolicyholderType;
(function (PolicyholderType) {
    PolicyholderType["Organization"] = "Organization";
    PolicyholderType["Person"] = "Person";
})(PolicyholderType || (PolicyholderType = {}));
export var PriorCarrierName;
(function (PriorCarrierName) {
    PriorCarrierName["Aegis"] = "Aegis";
    PriorCarrierName["Allstate"] = "Allstate";
    PriorCarrierName["AmericanBankers"] = "AmericanBankers";
    PriorCarrierName["AmericanModern"] = "AmericanModern";
    PriorCarrierName["AmericanReliable"] = "AmericanReliable";
    PriorCarrierName["AmericanSummit"] = "AmericanSummit";
    PriorCarrierName["Assurant"] = "Assurant";
    PriorCarrierName["Bankers"] = "Bankers";
    PriorCarrierName["Foremost"] = "Foremost";
    PriorCarrierName["Homesite"] = "Homesite";
    PriorCarrierName["Kin"] = "Kin";
    PriorCarrierName["LibertyMutual"] = "LibertyMutual";
    PriorCarrierName["Markel"] = "Markel";
    PriorCarrierName["NationalLloyds"] = "NationalLloyds";
    PriorCarrierName["NationalSecurity"] = "NationalSecurity";
    PriorCarrierName["NotListed"] = "NotListed";
    PriorCarrierName["PacificSpecialty"] = "PacificSpecialty";
    PriorCarrierName["Progressive"] = "Progressive";
    PriorCarrierName["Shelter"] = "Shelter";
    PriorCarrierName["StateFarm"] = "StateFarm";
    PriorCarrierName["TowerHill"] = "TowerHill";
    PriorCarrierName["Usaa"] = "USAA";
})(PriorCarrierName || (PriorCarrierName = {}));
export var PriorClaimCategory;
(function (PriorClaimCategory) {
    PriorClaimCategory["CollisionVehicleAircraft"] = "CollisionVehicleAircraft";
    PriorClaimCategory["Earthquake"] = "Earthquake";
    PriorClaimCategory["FireSmoke"] = "FireSmoke";
    PriorClaimCategory["Flood"] = "Flood";
    PriorClaimCategory["InteriorWater"] = "InteriorWater";
    PriorClaimCategory["Liability"] = "Liability";
    PriorClaimCategory["MedicalPayments"] = "MedicalPayments";
    PriorClaimCategory["Other"] = "Other";
    PriorClaimCategory["TheftBurglary"] = "TheftBurglary";
    PriorClaimCategory["VandalismOrMaliciousMischief"] = "VandalismOrMaliciousMischief";
    PriorClaimCategory["WeatherHail"] = "WeatherHail";
    PriorClaimCategory["WeatherLightning"] = "WeatherLightning";
    PriorClaimCategory["WeatherWater"] = "WeatherWater";
    PriorClaimCategory["WeatherWind"] = "WeatherWind";
})(PriorClaimCategory || (PriorClaimCategory = {}));
export var PriorClaimSource;
(function (PriorClaimSource) {
    PriorClaimSource["Internal"] = "Internal";
    PriorClaimSource["ThirdParty"] = "ThirdParty";
    PriorClaimSource["UserDeclared"] = "UserDeclared";
})(PriorClaimSource || (PriorClaimSource = {}));
export var PriorClaimsQuestionsFieldName;
(function (PriorClaimsQuestionsFieldName) {
    PriorClaimsQuestionsFieldName["Amount"] = "amount";
    PriorClaimsQuestionsFieldName["Catastrophe"] = "catastrophe";
    PriorClaimsQuestionsFieldName["Category"] = "category";
    PriorClaimsQuestionsFieldName["Date"] = "date";
})(PriorClaimsQuestionsFieldName || (PriorClaimsQuestionsFieldName = {}));
export var PriorInsurance;
(function (PriorInsurance) {
    PriorInsurance["BuyingNewHome"] = "BuyingNewHome";
    PriorInsurance["NoInsurance"] = "NoInsurance";
    PriorInsurance["RentingNewHome"] = "RentingNewHome";
    PriorInsurance["SwitchingCarriers"] = "SwitchingCarriers";
})(PriorInsurance || (PriorInsurance = {}));
export var PriorPolicyExpirationDate;
(function (PriorPolicyExpirationDate) {
    PriorPolicyExpirationDate["Between1_7"] = "Between1_7";
    PriorPolicyExpirationDate["Between8_30"] = "Between8_30";
    PriorPolicyExpirationDate["Between31_90"] = "Between31_90";
    PriorPolicyExpirationDate["MoreThan90"] = "MoreThan90";
    PriorPolicyExpirationDate["NeverBeenInsured"] = "NeverBeenInsured";
})(PriorPolicyExpirationDate || (PriorPolicyExpirationDate = {}));
export var ProductTypeName;
(function (ProductTypeName) {
    ProductTypeName["FullRepair"] = "FullRepair";
    ProductTypeName["MhHomeowners"] = "MHHomeowners";
    ProductTypeName["MhLandlord"] = "MHLandlord";
})(ProductTypeName || (ProductTypeName = {}));
export var PurchaseDate;
(function (PurchaseDate) {
    PurchaseDate["Between1_7"] = "Between1_7";
    PurchaseDate["Between8_30"] = "Between8_30";
    PurchaseDate["Between31_90"] = "Between31_90";
    PurchaseDate["CurrentlyInTheBuyingProcess"] = "CurrentlyInTheBuyingProcess";
    PurchaseDate["MoreThan90"] = "MoreThan90";
})(PurchaseDate || (PurchaseDate = {}));
export var QuestionType;
(function (QuestionType) {
    QuestionType["Amount"] = "Amount";
    QuestionType["Checkbox"] = "Checkbox";
    QuestionType["Date"] = "Date";
    QuestionType["Dropdown"] = "Dropdown";
})(QuestionType || (QuestionType = {}));
export var QuoteListItemsSortBy;
(function (QuoteListItemsSortBy) {
    QuoteListItemsSortBy["CreatedTimestamp"] = "CreatedTimestamp";
    QuoteListItemsSortBy["EffectiveDate"] = "EffectiveDate";
    QuoteListItemsSortBy["UpdatedTimestamp"] = "UpdatedTimestamp";
})(QuoteListItemsSortBy || (QuoteListItemsSortBy = {}));
export var Relationship;
(function (Relationship) {
    Relationship["Friend"] = "Friend";
    Relationship["Officer"] = "Officer";
    Relationship["Other"] = "Other";
    Relationship["OtherFamily"] = "OtherFamily";
    Relationship["Owner"] = "Owner";
    Relationship["Partner"] = "Partner";
    Relationship["Spouse"] = "Spouse";
    Relationship["Trustee"] = "Trustee";
})(Relationship || (Relationship = {}));
export var RemoveAdditionalInterestBlockReason;
(function (RemoveAdditionalInterestBlockReason) {
    RemoveAdditionalInterestBlockReason["ActiveEndorsement"] = "ActiveEndorsement";
    RemoveAdditionalInterestBlockReason["ActiveRenewal"] = "ActiveRenewal";
    RemoveAdditionalInterestBlockReason["AdditionalInterestNotFound"] = "AdditionalInterestNotFound";
    RemoveAdditionalInterestBlockReason["NonRenewalIssued"] = "NonRenewalIssued";
    RemoveAdditionalInterestBlockReason["PolicyCancelled"] = "PolicyCancelled";
    RemoveAdditionalInterestBlockReason["PolicyExpired"] = "PolicyExpired";
    RemoveAdditionalInterestBlockReason["WebAppApiRequestFailed"] = "WebAppApiRequestFailed";
    RemoveAdditionalInterestBlockReason["WebAppApiRequestNotValid"] = "WebAppApiRequestNotValid";
})(RemoveAdditionalInterestBlockReason || (RemoveAdditionalInterestBlockReason = {}));
export var RenewalFilterByStatus;
(function (RenewalFilterByStatus) {
    RenewalFilterByStatus["All"] = "All";
    RenewalFilterByStatus["DiscardedRenewals"] = "DiscardedRenewals";
    RenewalFilterByStatus["Failed"] = "Failed";
    RenewalFilterByStatus["NonRenewalIssued"] = "NonRenewalIssued";
    RenewalFilterByStatus["OfferSent"] = "OfferSent";
    RenewalFilterByStatus["RenewalIssued"] = "RenewalIssued";
    RenewalFilterByStatus["RenewalUwAccepted"] = "RenewalUWAccepted";
    RenewalFilterByStatus["UpcomingRenewals"] = "UpcomingRenewals";
    RenewalFilterByStatus["UwReview"] = "UwReview";
})(RenewalFilterByStatus || (RenewalFilterByStatus = {}));
export var RenewalListItemsSortBy;
(function (RenewalListItemsSortBy) {
    RenewalListItemsSortBy["CreatedTimestamp"] = "CreatedTimestamp";
    RenewalListItemsSortBy["EffectiveDate"] = "EffectiveDate";
    RenewalListItemsSortBy["UpdatedTimestamp"] = "UpdatedTimestamp";
})(RenewalListItemsSortBy || (RenewalListItemsSortBy = {}));
export var RenewalStatus;
(function (RenewalStatus) {
    RenewalStatus["Discarded"] = "Discarded";
    RenewalStatus["Issued"] = "Issued";
    RenewalStatus["NonRenewalIssued"] = "NonRenewalIssued";
    RenewalStatus["NotApplicable"] = "NotApplicable";
    RenewalStatus["OfferSent"] = "OfferSent";
    RenewalStatus["OfferSentFailed"] = "OfferSentFailed";
    RenewalStatus["PaymentFailed"] = "PaymentFailed";
    RenewalStatus["PricingFailed"] = "PricingFailed";
    RenewalStatus["UwAccepted"] = "UWAccepted";
    RenewalStatus["UwFailed"] = "UWFailed";
    RenewalStatus["UwReview"] = "UWReview";
    RenewalStatus["Upcoming"] = "Upcoming";
})(RenewalStatus || (RenewalStatus = {}));
export var ResidenceBurglaryValue;
(function (ResidenceBurglaryValue) {
    ResidenceBurglaryValue["Dollars5K"] = "Dollars5K";
    ResidenceBurglaryValue["Dollars10K"] = "Dollars10K";
    ResidenceBurglaryValue["Dollars15K"] = "Dollars15K";
    ResidenceBurglaryValue["Dollars20K"] = "Dollars20K";
    ResidenceBurglaryValue["Dollars30K"] = "Dollars30K";
    ResidenceBurglaryValue["Dollars40K"] = "Dollars40K";
    ResidenceBurglaryValue["Dollars50K"] = "Dollars50K";
})(ResidenceBurglaryValue || (ResidenceBurglaryValue = {}));
export var RoofCondition;
(function (RoofCondition) {
    RoofCondition["Excellent"] = "Excellent";
    RoofCondition["Fair"] = "Fair";
    RoofCondition["Good"] = "Good";
    RoofCondition["Poor"] = "Poor";
    RoofCondition["Severe"] = "Severe";
    RoofCondition["Unknown"] = "Unknown";
})(RoofCondition || (RoofCondition = {}));
export var RoofShape;
(function (RoofShape) {
    RoofShape["BowedCurvedArched"] = "BowedCurvedArched";
    RoofShape["Flat"] = "Flat";
    RoofShape["Gable"] = "Gable";
    RoofShape["Hip"] = "Hip";
    RoofShape["NotListed"] = "NotListed";
    RoofShape["Shed"] = "Shed";
})(RoofShape || (RoofShape = {}));
export var SearchResultType;
(function (SearchResultType) {
    SearchResultType["Policy"] = "Policy";
    SearchResultType["Quote"] = "Quote";
    SearchResultType["Renewal"] = "Renewal";
    SearchResultType["Sequoia"] = "Sequoia";
})(SearchResultType || (SearchResultType = {}));
export var SettlementOption;
(function (SettlementOption) {
    SettlementOption["ActualCashValue"] = "ActualCashValue";
    SettlementOption["ExtendedReplacementCost"] = "ExtendedReplacementCost";
    SettlementOption["FullRepairCost"] = "FullRepairCost";
    SettlementOption["ReplacementCost"] = "ReplacementCost";
})(SettlementOption || (SettlementOption = {}));
export var SkirtingType;
(function (SkirtingType) {
    SkirtingType["Lattice"] = "Lattice";
    SkirtingType["MasonryBrick"] = "MasonryBrick";
    SkirtingType["Metal"] = "Metal";
    SkirtingType["NotFullyEnclosed"] = "NotFullyEnclosed";
    SkirtingType["NotListed"] = "NotListed";
    SkirtingType["Vinyl"] = "Vinyl";
})(SkirtingType || (SkirtingType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["Ascending"] = "Ascending";
    SortOrder["Descending"] = "Descending";
})(SortOrder || (SortOrder = {}));
export var TypeOfFuelValue;
(function (TypeOfFuelValue) {
    TypeOfFuelValue["Coal"] = "Coal";
    TypeOfFuelValue["Electric"] = "Electric";
    TypeOfFuelValue["Kerosene"] = "Kerosene";
    TypeOfFuelValue["NotListed"] = "NotListed";
    TypeOfFuelValue["Solar"] = "Solar";
    TypeOfFuelValue["Wood"] = "Wood";
})(TypeOfFuelValue || (TypeOfFuelValue = {}));
export var UnderwritingDecision;
(function (UnderwritingDecision) {
    UnderwritingDecision["Accept"] = "accept";
    UnderwritingDecision["None"] = "none";
    UnderwritingDecision["Reject"] = "reject";
})(UnderwritingDecision || (UnderwritingDecision = {}));
export var UnitLocation;
(function (UnitLocation) {
    UnitLocation["LargeManufacturedHome"] = "LargeManufacturedHome";
    UnitLocation["OnMyOwnLand"] = "OnMyOwnLand";
    UnitLocation["SmallManufacturedHome"] = "SmallManufacturedHome";
    UnitLocation["Unknown"] = "Unknown";
})(UnitLocation || (UnitLocation = {}));
export var VacancyReason;
(function (VacancyReason) {
    VacancyReason["BetweenTenants"] = "BetweenTenants";
    VacancyReason["Condemned"] = "Condemned";
    VacancyReason["ForSale"] = "ForSale";
    VacancyReason["Other"] = "Other";
    VacancyReason["UnderRenovation"] = "UnderRenovation";
})(VacancyReason || (VacancyReason = {}));
export var VisitorsInAMonthValue;
(function (VisitorsInAMonthValue) {
    VisitorsInAMonthValue["Five"] = "Five";
    VisitorsInAMonthValue["Four"] = "Four";
    VisitorsInAMonthValue["One"] = "One";
    VisitorsInAMonthValue["SixOrMore"] = "SixOrMore";
    VisitorsInAMonthValue["Three"] = "Three";
    VisitorsInAMonthValue["Two"] = "Two";
    VisitorsInAMonthValue["Zero"] = "Zero";
})(VisitorsInAMonthValue || (VisitorsInAMonthValue = {}));
export var WaterDamageDeductible;
(function (WaterDamageDeductible) {
    WaterDamageDeductible["Dollars2K500"] = "Dollars2K500";
    WaterDamageDeductible["Dollars5K"] = "Dollars5K";
    WaterDamageDeductible["Dollars10K"] = "Dollars10K";
})(WaterDamageDeductible || (WaterDamageDeductible = {}));
export var WindHailDeductible;
(function (WindHailDeductible) {
    WindHailDeductible["Dollars1K"] = "Dollars1K";
    WindHailDeductible["Dollars2K500"] = "Dollars2K500";
    WindHailDeductible["Dollars5K"] = "Dollars5K";
    WindHailDeductible["Dollars10K"] = "Dollars10K";
    WindHailDeductible["Dollars500"] = "Dollars500";
})(WindHailDeductible || (WindHailDeductible = {}));
export const CoverageBooleanFragmentFragmentDoc = gql `
  fragment CoverageBooleanFragment on CoverageBoolean {
    defaultValue
    value
    valueIsHidden
    valueIsCustomizable
  }
`;
export const EndorsementExtraCoveragesFragmentDoc = gql `
  fragment EndorsementExtraCoverages on UnitLevelCoverages {
    buildersRisk {
      ...CoverageBooleanFragment
    }
    debrisRemoval {
      defaultValue
      value
      valueCustomization {
        options {
          label
          value
        }
      }
      valueIsHidden
      valueIsCustomizable
    }
    earthquake {
      defaultValue
      value
      valueCustomization {
        options
      }
      valueIsHidden
      valueIsCustomizable
    }
    enhancedCoverage {
      ...CoverageBooleanFragment
    }
    equipmentBreakdown {
      defaultValue
      value
      valueIsHidden
      valueIsCustomizable
    }
    fortifiedRoofUpgrade {
      ...CoverageBooleanFragment
    }
    golfCarts {
      defaultValue
      value
      valueCustomization {
        options
      }
      valueIsHidden
      valueIsCustomizable
    }
    incidentalFarming {
      ...CoverageBooleanFragment
    }
    landlordPersonalInjury {
      ...CoverageBooleanFragment
    }
    lossAssessment {
      defaultValue
      value
      valueCustomization {
        options {
          label
          value
        }
      }
      valueIsHidden
      valueIsCustomizable
    }
    mineSubsidence {
      ...CoverageBooleanFragment
    }
    mineSubsidenceScheduled {
      value {
        locator
        description
        value
      }
      valueIsHidden
      valueIsCustomizable
    }
    residenceBurglary {
      defaultValue
      value
      valueCustomization {
        options {
          label
          value
        }
      }
      valueIsHidden
      valueIsCustomizable
    }
    roofPaymentSchedule {
      ...CoverageBooleanFragment
    }
    secondaryResidenceLiability {
      value {
        fieldGroupLocator
        address
      }
      valueIsHidden
      valueIsCustomizable
    }
    sinkhole {
      ...CoverageBooleanFragment
    }
    tripCollision {
      ...CoverageBooleanFragment
    }
    vacationRental {
      ...CoverageBooleanFragment
    }
    vandalismOrMaliciousMischief {
      ...CoverageBooleanFragment
    }
    waterBackupAndSumpOverflow {
      defaultValue
      value
      valueCustomization {
        options {
          label
          value
        }
      }
      valueIsHidden
      valueIsCustomizable
    }
    windstormOrHailExclusion {
      defaultValue
      value
      valueIsHidden
      valueIsCustomizable
    }
  }
  ${CoverageBooleanFragmentFragmentDoc}
`;
export const EndorsementUnderwritingFragmentDoc = gql `
  fragment EndorsementUnderwriting on Policy {
    policyLevelUnderwritingAnswers {
      animalBite
      conviction
      cancellationRenew {
        cancellationRenew
        reasonCancellationRenew
      }
    }
    policyLevelUnderwritingQuestions {
      fieldName
      default
      options
    }
    units {
      unitLevelUnderwritingQuestions {
        fieldName
        default
        options
      }
      unitLevelUnderwritingAnswers {
        animalBite {
          isHidden
          value
        }
        automaticSprinkler {
          isHidden
          value
        }
        burglarAlarm {
          isHidden
          value
        }
        business {
          businessDescription {
            isHidden
            value
          }
          businessEmployeesOnPremises {
            isHidden
            value
          }
          businessOnPremises {
            isHidden
            value
          }
          daycareOnPremises {
            isHidden
            value
          }
          visitorsInAMonth {
            isHidden
            value
          }
        }
        mortgage {
          isHidden
          value
        }
        propertyWithFireProtection {
          isHidden
          value
        }
        secureRails {
          isHidden
          value
        }
        stormMitigationFortified {
          isHidden
          value
        }
        stormMitigationImpactglass {
          isHidden
          value
        }
        stormMitigationShutters {
          isHidden
          value
        }
        supplementalHeating {
          pleaseDescribe {
            isHidden
            value
          }
          sourceOfHeat {
            isHidden
            value
          }
          sourceOfHeatInstallation {
            isHidden
            value
          }
          typeOfFuel {
            isHidden
            value
          }
        }
        swimmingPool {
          divingBoard {
            isHidden
            value
          }
          divingBoardSlideLiabilityExtension {
            isHidden
            value
          }
          fourFeetFence {
            isHidden
            value
          }
          swimmingPool {
            isHidden
            value
          }
        }
        thermoStaticControl {
          isHidden
          value
        }
        trampoline {
          trampolineLiability {
            isHidden
            value
          }
          trampolineLiabilityExtension {
            isHidden
            value
          }
          trampolineSafetyNet {
            isHidden
            value
          }
        }
        unitIsTied {
          isHidden
          value
        }
        unrepairedDamages {
          isHidden
          value
        }
        utilityServices {
          isHidden
          value
        }
        wroughtIron {
          isHidden
          value
        }
      }
    }
  }
`;
export const AchPaymentMethodFragmentFragmentDoc = gql `
  fragment AchPaymentMethodFragment on AchPaymentMethod {
    id
    default
    bankName
    last4Digits
  }
`;
export const CreditCardPaymentMethodFragmentFragmentDoc = gql `
  fragment CreditCardPaymentMethodFragment on CreditCardPaymentMethod {
    last4Digits
    id
    default
    brand
    expiration {
      month
      year
    }
  }
`;
export const PolicyWithPaymentMethodsFragmentDoc = gql `
  fragment PolicyWithPaymentMethods on Policy {
    policyLocator
    paymentMethods {
      achPaymentMethods {
        ...AchPaymentMethodFragment
      }
      creditCardPaymentMethods {
        ...CreditCardPaymentMethodFragment
      }
    }
  }
  ${AchPaymentMethodFragmentFragmentDoc}
  ${CreditCardPaymentMethodFragmentFragmentDoc}
`;
export const PendingCancellationPolicyListItemWithoutAgencyDataFragmentDoc = gql `
  fragment PendingCancellationPolicyListItemWithoutAgencyData on Policy {
    policyLocator
    policyholder {
      policyholderLocator
      firstName
      lastName
    }
    previousAddress {
      streetAddress
      city
      zipCode
      state
      unitNumber
      county
      countryCode
    }
    cancellationEffectiveDate
    productTypeName
    status
    description
    units {
      pricing {
        grossPremium
      }
    }
    startDate
    endDate
    updatedDate
  }
`;
export const PendingCancellationPolicyListItemFragmentDoc = gql `
  fragment PendingCancellationPolicyListItem on Policy {
    ...PendingCancellationPolicyListItemWithoutAgencyData
    agencyInformation {
      agencyName
      agentName
    }
  }
  ${PendingCancellationPolicyListItemWithoutAgencyDataFragmentDoc}
`;
export const PendingCancellationPolicyListItemWithoutAgencyNameFragmentDoc = gql `
  fragment PendingCancellationPolicyListItemWithoutAgencyName on Policy {
    ...PendingCancellationPolicyListItemWithoutAgencyData
    agencyInformation {
      agentName
    }
  }
  ${PendingCancellationPolicyListItemWithoutAgencyDataFragmentDoc}
`;
export const AddressFragmentFragmentDoc = gql `
  fragment AddressFragment on Address {
    streetAddress
    city
    zipCode
    state
    unitNumber
    county
    countryCode
  }
`;
export const PolicyholderFragmentFragmentDoc = gql `
  fragment PolicyholderFragment on Policyholder {
    describeOrgType
    emailAddress
    firstName
    lastName
    mailingAddress {
      ...AddressFragment
    }
    type
    secondaryContactNumber
    occupationType
    numberOfVehicles
    middleName
    orgName
    orgType
    policyholderLocator
    primaryContactNumber
    repRelationToOrg
  }
  ${AddressFragmentFragmentDoc}
`;
export const AdditionalInterestFragmentFragmentDoc = gql `
  fragment AdditionalInterestFragment on AdditionalInterest {
    type
    accountNumber
    additionalInterestId
    city
    email
    lotUnit
    name
    state
    streetAddress
    zipCode
  }
`;
export const AdditionalInterestFragmentWithBillingFragmentDoc = gql `
  fragment AdditionalInterestFragmentWithBilling on AdditionalInterest {
    ...AdditionalInterestFragment
    isBilling
  }
  ${AdditionalInterestFragmentFragmentDoc}
`;
export const NoteFragmentFragmentDoc = gql `
  fragment NoteFragment on PolicyNote {
    authorId
    authorName
    createdDate
    content
    noteLocator
  }
`;
export const DocumentFragmentFragmentDoc = gql `
  fragment DocumentFragment on PolicyDocument {
    urlExpirationTimestamp
    url
    type
    policyModificationLocator
    fileName
    documentLocator
    displayName
    createdTimestamp
  }
`;
export const RenewalBaseFragmentDoc = gql `
  fragment RenewalBase on Renewal {
    renewalLocator
    policyLocator
    premium
    totalDue
    status
    renewalTerm {
      effectiveDate
      endDate
    }
    paymentMethod
    selectedPlan
    paymentScheduleName
    createdDate
    issuedDate
    nonRenewalReason
    nonRenewalIssueDate
    discardedDate
    discardedBy
    underwritingReviewReasons
    description
    productTypeName
    offerDocument {
      documentLocator
      url
      fileName
      displayName
      type
      urlExpirationTimestamp
      createdTimestamp
      policyModificationLocator
    }
  }
`;
export const PolicyBaseFragmentDoc = gql `
  fragment PolicyBase on Policy {
    policyLocator
    policyholder {
      ...PolicyholderFragment
    }
    status
    productTypeName
    selectedQuoteLocator
    mainUnitType
    paymentScheduleName
    startDate
    startDateAfterUWReview
    additionalInterests {
      ...AdditionalInterestFragmentWithBilling
    }
    issuedDate
    endDate
    previousAddress {
      ...AddressFragment
    }
    description
    additionalInsured {
      adFirstName
      adLastName
      locator
      relationshipIndividual
    }
    cancellationCreatedDate
    cancellationEffectiveDate
    bookConversion {
      source
      previousPolicyId
    }
    insuredDateOfBirth
    isEsigned
    isAgentsSignResponsibility
    paymentMethods {
      achPaymentMethods {
        bankName
        id
        last4Digits
        default
      }
      creditCardPaymentMethods {
        last4Digits
        id
        expiration {
          month
          year
        }
        default
        brand
      }
    }
    notes {
      ...NoteFragment
    }
    physicallyMailDocuments
    documents {
      ...DocumentFragment
    }
    units {
      unitId
      address {
        ...AddressFragment
      }
      construction {
        homeType
        manufacturerName
        makeCustom
        modelHome
        homeFixtures
        roofShape
        roofYearYyyy
        roofCondition
        totalSquareFootage
        homeWidth
        homeLength
        modelYear
        homeHudNumber
        skirtingType
      }
      details {
        unitLocation
        purchaseDate
        communityName
        latitude
        longitude
        formattedLocationAddress
      }
      pricing {
        totalDue
        grossPremium
        grossTaxes
        fees {
          amount
          name
        }
        grossFees
        commissions {
          amount
          recipient
        }
        installments {
          dueDate
          fees
          premium
          taxes
        }
      }
      selectedPlan
      valuationReportUrl
    }
    renewals {
      ...RenewalBase
    }
  }
  ${PolicyholderFragmentFragmentDoc}
  ${AdditionalInterestFragmentWithBillingFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${NoteFragmentFragmentDoc}
  ${DocumentFragmentFragmentDoc}
  ${RenewalBaseFragmentDoc}
`;
export const RenewalWithAgentNameFragmentDoc = gql `
  fragment RenewalWithAgentName on Renewal {
    ...RenewalBase
    assignedAgentName
  }
  ${RenewalBaseFragmentDoc}
`;
export const PolicyWithAgentNameFragmentDoc = gql `
  fragment PolicyWithAgentName on Policy {
    ...PolicyBase
    renewals {
      ...RenewalWithAgentName
    }
    agencyInformation {
      agentId
      agentName
    }
  }
  ${PolicyBaseFragmentDoc}
  ${RenewalWithAgentNameFragmentDoc}
`;
export const RenewalWithAgencyDataFragmentDoc = gql `
  fragment RenewalWithAgencyData on Renewal {
    ...RenewalWithAgentName
    assignedAgencyName
  }
  ${RenewalWithAgentNameFragmentDoc}
`;
export const PolicyWithAgencyDataFragmentDoc = gql `
  fragment PolicyWithAgencyData on Policy {
    ...PolicyBase
    renewals {
      ...RenewalWithAgencyData
    }
    commissionablePartners {
      commissionablePartnerId
      commissionablePartnerName
    }
    agencyInformation {
      agentId
      agencyName
      agencyId
      agentName
    }
    endorsements {
      endorsementLocator
      note
      effectiveDate
      status
      isSocotraNative
    }
  }
  ${PolicyBaseFragmentDoc}
  ${RenewalWithAgencyDataFragmentDoc}
`;
export const RenewalWithCheckReceivalFragmentDoc = gql `
  fragment RenewalWithCheckReceival on Renewal {
    ...RenewalWithAgencyData
    checkReceival {
      createdBy
      createdTimestamp
      description
      updatedBy
    }
  }
  ${RenewalWithAgencyDataFragmentDoc}
`;
export const PolicyWithCheckReceivalDataFragmentDoc = gql `
  fragment PolicyWithCheckReceivalData on Policy {
    ...PolicyWithAgencyData
    stripeCustomerId
    renewals {
      ...RenewalWithCheckReceival
    }
  }
  ${PolicyWithAgencyDataFragmentDoc}
  ${RenewalWithCheckReceivalFragmentDoc}
`;
export const PolicyWithDocumentsFragmentDoc = gql `
  fragment PolicyWithDocuments on Policy {
    policyLocator
    documents {
      ...DocumentFragment
    }
  }
  ${DocumentFragmentFragmentDoc}
`;
export const PolicyWithNotesFragmentDoc = gql `
  fragment PolicyWithNotes on Policy {
    policyLocator
    notes {
      ...NoteFragment
    }
  }
  ${NoteFragmentFragmentDoc}
`;
export const PolicyWithStartDateAfterUwReviewFragmentDoc = gql `
  fragment PolicyWithStartDateAfterUWReview on Policy {
    policyLocator
    startDateAfterUWReview
  }
`;
export const PolicyWithUwResultFragmentDoc = gql `
  fragment PolicyWithUWResult on Policy {
    policyLocator
    underwritingNotes
  }
`;
export const PolicyListItemWithoutAgencyDataFragmentDoc = gql `
  fragment PolicyListItemWithoutAgencyData on Policy {
    policyLocator
    selectedQuoteLocator
    policyholder {
      policyholderLocator
      firstName
      lastName
    }
    previousAddress {
      ...AddressFragment
    }
    productTypeName
    status
    units {
      pricing {
        grossPremium
      }
    }
    bookConversion {
      source
    }
    issuedDate
    startDate
    isAgentsSignResponsibility
    physicallyMailDocuments
  }
  ${AddressFragmentFragmentDoc}
`;
export const PolicyListItemFragmentDoc = gql `
  fragment PolicyListItem on Policy {
    ...PolicyListItemWithoutAgencyData
    agencyInformation {
      agencyName
      agentName
    }
  }
  ${PolicyListItemWithoutAgencyDataFragmentDoc}
`;
export const PolicyListItemWithoutAgencyNameFragmentDoc = gql `
  fragment PolicyListItemWithoutAgencyName on Policy {
    ...PolicyListItemWithoutAgencyData
    agencyInformation {
      agentName
    }
  }
  ${PolicyListItemWithoutAgencyDataFragmentDoc}
`;
export const QuoteListItemWithoutAgencyDataFragmentDoc = gql `
  fragment QuoteListItemWithoutAgencyData on Policy {
    policyLocator
    selectedQuoteLocator
    startDateAfterUWReview
    policyholder {
      policyholderLocator
      firstName
      lastName
    }
    previousAddress {
      ...AddressFragment
    }
    productTypeName
    units {
      pricing {
        grossPremium
      }
    }
    createdDate
    updatedDate
  }
  ${AddressFragmentFragmentDoc}
`;
export const QuoteListItemFragmentDoc = gql `
  fragment QuoteListItem on Policy {
    ...QuoteListItemWithoutAgencyData
    agencyInformation {
      agencyName
      agentName
    }
  }
  ${QuoteListItemWithoutAgencyDataFragmentDoc}
`;
export const QuoteListItemWithoutAgencyNameFragmentDoc = gql `
  fragment QuoteListItemWithoutAgencyName on Policy {
    ...QuoteListItemWithoutAgencyData
    agencyInformation {
      agentName
    }
  }
  ${QuoteListItemWithoutAgencyDataFragmentDoc}
`;
export const RenewalListItemWithoutAgencyDataFragmentDoc = gql `
  fragment RenewalListItemWithoutAgencyData on Renewal {
    renewalLocator
    policyLocator
    policyholderName
    unitAddress {
      streetAddress
      city
      zipCode
      state
      unitNumber
      county
      countryCode
    }
    status
    premium
    renewalTerm {
      effectiveDate
      endDate
    }
    description
    issuedDate
    updatedDate
    nonRenewalReason
    nonRenewalIssueDate
    discardedDate
    productTypeName
  }
`;
export const RenewalListItemFragmentDoc = gql `
  fragment RenewalListItem on Renewal {
    ...RenewalListItemWithoutAgencyData
    assignedAgentName
    assignedAgencyName
  }
  ${RenewalListItemWithoutAgencyDataFragmentDoc}
`;
export const RenewalListItemWithoutAgencyNameFragmentDoc = gql `
  fragment RenewalListItemWithoutAgencyName on Renewal {
    ...RenewalListItemWithoutAgencyData
    assignedAgentName
  }
  ${RenewalListItemWithoutAgencyDataFragmentDoc}
`;
export const SequoiaListItemWithoutAgencyDataFragmentDoc = gql `
  fragment SequoiaListItemWithoutAgencyData on Policy {
    policyLocator
    selectedQuoteLocator
    policyholder {
      policyholderLocator
      firstName
      lastName
    }
    previousAddress {
      ...AddressFragment
    }
    priorInsuranceDetails {
      priorCarrierName
    }
    units {
      pricing {
        grossPremium
      }
    }
    startDate
    bookConversion {
      previousPolicyId
      source
    }
  }
  ${AddressFragmentFragmentDoc}
`;
export const SequoiaListItemFragmentDoc = gql `
  fragment SequoiaListItem on Policy {
    ...SequoiaListItemWithoutAgencyData
    agencyInformation {
      agencyName
      agentName
    }
  }
  ${SequoiaListItemWithoutAgencyDataFragmentDoc}
`;
export const SequoiaListItemWithoutAgencyNameFragmentDoc = gql `
  fragment SequoiaListItemWithoutAgencyName on Policy {
    ...SequoiaListItemWithoutAgencyData
    agencyInformation {
      agentName
    }
  }
  ${SequoiaListItemWithoutAgencyDataFragmentDoc}
`;
export const NewBusinessPolicyCommonDetailsFragmentFragmentDoc = gql `
  fragment NewBusinessPolicyCommonDetailsFragment on Policy {
    policyLocator
    selectedQuoteLocator
    startDate
    endDate
    step
  }
`;
export const PolicyLevelCoveragesFragmentFragmentDoc = gql `
  fragment PolicyLevelCoveragesFragment on Policy {
    policyLevelCoverages {
      scheduledPersonalProperty {
        valueIsCustomizable
        valueIsHidden
        value {
          description
          fieldGroupLocator
          type
          value
        }
      }
      identityFraudExpense {
        defaultValue
        value
        valueIsCustomizable
        valueIsHidden
      }
    }
  }
`;
export const BasicUnitDetailsFragmentFragmentDoc = gql `
  fragment BasicUnitDetailsFragment on PolicyUnit {
    unitId
    exposureLocator
  }
`;
export const UnitLevelBaseCoveragesFragmentFragmentDoc = gql `
  fragment UnitLevelBaseCoveragesFragment on UnitLevelCoverages {
    coverageA {
      settlementOptionCustomization {
        options
      }
      settlementOption
      settlementOptionIsCustomizable
      settlementOptionIsHidden
      value
      valueCustomization {
        constraint {
          dependsOn
          operator
        }
        max
        min
        step
      }
      valueIsHidden
      valueIsCustomizable
    }
    coverageB {
      defaultSettlementOption
      settlementOption
      settlementOptionCustomization {
        options
      }
      settlementOptionIsCustomizable
      settlementOptionIsHidden
      value
      valueCustomization {
        constraint {
          dependsOn
          operator
        }
        max
        min
        step
      }
      valueIsCustomizable
      valueIsHidden
    }
    coverageC {
      defaultSettlementOption
      settlementOption
      settlementOptionCustomization {
        options
      }
      settlementOptionIsCustomizable
      settlementOptionIsHidden
      value
      valueCustomization {
        constraint {
          dependsOn
          operator
        }
        max
        min
        step
      }
      valueIsCustomizable
      valueIsHidden
    }
    coverageDLossOfUse {
      value
      valueCustomization {
        options
      }
      valueIsCustomizable
      valueIsHidden
    }
    coverageEPersonalLiability {
      value
      valueCustomization {
        constraint {
          dependsOn
          operator
        }
        options
      }
      valueIsCustomizable
      valueIsHidden
    }
    coverageEPremisesLiability {
      value
      valueCustomization {
        constraint {
          dependsOn
          operator
        }
        options
      }
      valueIsCustomizable
      valueIsHidden
    }
    coverageFMedicalPaymentToOthers {
      value
      valueCustomization {
        options {
          label
          value
        }
      }
      valueIsCustomizable
      valueIsHidden
    }
    deductibles {
      allOtherPerilsDeductible
      allOtherPerilsDeductibleCustomization {
        constraint {
          dependsOn
          operator
        }
        options
      }
      allOtherPerilsDeductibleIsCustomizable
      allOtherPerilsDeductibleIsHidden
      waterDamageDeductible
      waterDamageDeductibleCustomization {
        options
      }
      waterDamageDeductibleIsCustomizable
      waterDamageDeductibleIsHidden
      windHailDeductible
      windHailDeductibleCustomization {
        constraint {
          dependsOn
          operator
        }
        options
      }
      windHailDeductibleIsCustomizable
      windHailDeductibleIsHidden
    }
    waterDamage {
      value
      valueCustomization {
        options
      }
      valueIsCustomizable
      valueIsHidden
    }
    animalLiability {
      value
      valueCustomization {
        options {
          label
          value
        }
      }
      valueIsCustomizable
      valueIsHidden
    }
    fungiWetOrDryRotOrBacteriaProperty {
      value
      valueCustomization {
        options
      }
      valueIsHidden
      valueIsCustomizable
    }
    damageToPropertyOfOthers {
      value
      valueCustomization {
        constraint {
          dependsOn
          operator
        }
        options
      }
      valueIsCustomizable
      valueIsHidden
    }
    inflationGuard {
      value
      valueCustomization {
        options
      }
      valueIsHidden
      valueIsCustomizable
    }
  }
`;
export const BasicUnitDetailsWithUnitLevelCoveragesFragmentFragmentDoc = gql `
  fragment BasicUnitDetailsWithUnitLevelCoveragesFragment on PolicyUnit {
    ...BasicUnitDetailsFragment
    unitLevelCoverages {
      buildersRisk {
        ...CoverageBooleanFragment
      }
      debrisRemoval {
        defaultValue
        value
        valueCustomization {
          options {
            label
            value
          }
        }
        valueIsHidden
        valueIsCustomizable
      }
      divingBoardSlideLiabilityExtension {
        ...CoverageBooleanFragment
      }
      earthquake {
        defaultValue
        value
        valueCustomization {
          options
        }
        valueIsHidden
        valueIsCustomizable
      }
      enhancedCoverage {
        ...CoverageBooleanFragment
      }
      equipmentBreakdown {
        defaultValue
        value
        valueIsCustomizable
        valueIsHidden
      }
      fortifiedRoofUpgrade {
        ...CoverageBooleanFragment
      }
      incidentalFarming {
        ...CoverageBooleanFragment
      }
      landlordPersonalInjury {
        ...CoverageBooleanFragment
      }
      lossAssessment {
        defaultValue
        value
        valueCustomization {
          options {
            label
            value
          }
        }
        valueIsHidden
        valueIsCustomizable
      }
      mineSubsidence {
        ...CoverageBooleanFragment
      }
      mineSubsidenceScheduled {
        valueIsCustomizable
        valueIsHidden
        value {
          description
          locator
          value
        }
      }
      golfCarts {
        defaultValue
        value
        valueCustomization {
          options
        }
        valueIsHidden
        valueIsCustomizable
      }
      vacationRental {
        ...CoverageBooleanFragment
      }
      residenceBurglary {
        defaultValue
        value
        valueCustomization {
          constraint {
            dependsOn
            operator
          }
          options {
            label
            value
          }
        }
        valueIsHidden
        valueIsCustomizable
      }
      roofPaymentSchedule {
        ...CoverageBooleanFragment
      }
      secondaryResidenceLiability {
        value {
          fieldGroupLocator
          address
        }
        valueIsHidden
        valueIsCustomizable
      }
      sinkhole {
        ...CoverageBooleanFragment
      }
      trampolineLiabilityExtension {
        ...CoverageBooleanFragment
      }
      tripCollision {
        ...CoverageBooleanFragment
      }
      vandalismOrMaliciousMischief {
        ...CoverageBooleanFragment
      }
      waterBackupAndSumpOverflow {
        defaultValue
        value
        valueCustomization {
          options {
            label
            value
          }
        }
        valueIsHidden
        valueIsCustomizable
      }
      windstormOrHailExclusion {
        defaultValue
        value
        valueIsHidden
        valueIsCustomizable
      }
      ...UnitLevelBaseCoveragesFragment
    }
  }
  ${BasicUnitDetailsFragmentFragmentDoc}
  ${CoverageBooleanFragmentFragmentDoc}
  ${UnitLevelBaseCoveragesFragmentFragmentDoc}
`;
export const UnitDetailsFragmentFragmentDoc = gql `
  fragment UnitDetailsFragment on PolicyUnit {
    address {
      ...AddressFragment
    }
    construction {
      homeType
      manufacturerName
      makeCustom
      modelHome
      homeFixtures
      roofShape
      roofYearYyyy
      roofCondition
      totalSquareFootage
      homeWidth
      homeLength
      modelYear
      homeHudNumber
      skirtingType
    }
    ...BasicUnitDetailsWithUnitLevelCoveragesFragment
    details {
      unitLocation
      purchaseDate
      communityName
      latitude
      longitude
      formattedLocationAddress
      isDetectedCommunity
    }
    coverageDetails {
      covered
      notCovered
    }
    selectedPlan
    unitLevelUnderwritingQuestions {
      fieldName
      default
      options
    }
    unitLevelUnderwritingAnswers {
      animalBite {
        isHidden
        value
      }
      automaticSprinkler {
        isHidden
        value
      }
      burglarAlarm {
        isHidden
        value
      }
      business {
        businessDescription {
          isHidden
          value
        }
        businessEmployeesOnPremises {
          isHidden
          value
        }
        businessOnPremises {
          value
          isHidden
        }
        daycareOnPremises {
          isHidden
          value
        }
        visitorsInAMonth {
          isHidden
          value
        }
      }
      mortgage {
        isHidden
        value
      }
      propertyWithFireProtection {
        isHidden
        value
      }
      stormMitigationFortified {
        isHidden
        value
      }
      stormMitigationImpactglass {
        isHidden
        value
      }
      stormMitigationShutters {
        isHidden
        value
      }
      secureRails {
        isHidden
        value
      }
      supplementalHeating {
        pleaseDescribe {
          isHidden
          value
        }
        sourceOfHeat {
          value
          isHidden
        }
        sourceOfHeatInstallation {
          isHidden
          value
        }
        typeOfFuel {
          isHidden
          value
        }
      }
      thermoStaticControl {
        isHidden
        value
      }
      swimmingPool {
        divingBoard {
          isHidden
          value
        }
        divingBoardSlideLiabilityExtension {
          isHidden
          value
        }
        fourFeetFence {
          isHidden
          value
        }
        swimmingPool {
          isHidden
          value
        }
      }
      trampoline {
        trampolineLiability {
          isHidden
          value
        }
        trampolineLiabilityExtension {
          isHidden
          value
        }
        trampolineSafetyNet {
          isHidden
          value
        }
      }
      unitIsTied {
        isHidden
        value
      }
      unrepairedDamages {
        isHidden
        value
      }
      utilityServices {
        isHidden
        value
      }
      wroughtIron {
        isHidden
        value
      }
    }
    usage
    vacancyReason
    valuationReportUrl
  }
  ${AddressFragmentFragmentDoc}
  ${BasicUnitDetailsWithUnitLevelCoveragesFragmentFragmentDoc}
`;
export const PricingFragmentFragmentDoc = gql `
  fragment PricingFragment on UnitPricing {
    commissions {
      amount
      recipient
    }
    fees {
      name
      amount
    }
    grossTaxes
    grossFees
    grossPremium
    totalDue
  }
`;
export const PolicyOffersFragmentFragmentDoc = gql `
  fragment PolicyOffersFragment on Policy {
    offers {
      quoteLocator
      plan
      pricing {
        ...PricingFragment
      }
      quote {
        homeCoverage
        lossOfUse
        medicalPaymentToOther
        otherStructures
        personalLiability
        premisesLiability
        standardDeductible
        windHailDeductible
        yourBelongings
        waterDamageDeductible
        waterDamage
        roofPaymentSchedule
      }
      homeCoverageDescription
      yourBelongingsDescription
    }
  }
  ${PricingFragmentFragmentDoc}
`;
export const NewBusinessPolicyCreatedFragmentFragmentDoc = gql `
  fragment NewBusinessPolicyCreatedFragment on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    policyholder {
      ...PolicyholderFragment
    }
    productTypeName
    mainUnitType
    previousAddress {
      ...AddressFragment
    }
    additionalInsured {
      adFirstName
      adLastName
      locator
      relationshipIndividual
    }
    gotInsuranceScoreHit
    bookConversion {
      source
      previousPolicyId
    }
    priorInsuranceDetails {
      priorInsurance
      priorCarrierName
      priorPolicyExpirationDate
    }
    insuredDateOfBirth
    isEsigned
    isAgentsSignResponsibility
    isInternalAgency
    physicallyMailDocuments
    hasAnotherCoverTreePolicy
    hasAutoPolicy
    documents {
      ...DocumentFragment
    }
    ...PolicyLevelCoveragesFragment
    policyLevelUnderwritingAnswers {
      animalBite
      conviction
      cancellationRenew {
        cancellationRenew
        reasonCancellationRenew
      }
    }
    policyLevelUnderwritingQuestions {
      fieldName
      default
      options
    }
    units {
      ...UnitDetailsFragment
    }
    ...PolicyOffersFragment
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${PolicyholderFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${DocumentFragmentFragmentDoc}
  ${PolicyLevelCoveragesFragmentFragmentDoc}
  ${UnitDetailsFragmentFragmentDoc}
  ${PolicyOffersFragmentFragmentDoc}
`;
export const BasicUnitDetailsWithUwQuestionsFragmentFragmentDoc = gql `
  fragment BasicUnitDetailsWithUWQuestionsFragment on PolicyUnit {
    unitLevelUnderwritingAnswers {
      animalBite {
        value
        isHidden
      }
      automaticSprinkler {
        value
        isHidden
      }
      burglarAlarm {
        value
        isHidden
      }
      business {
        businessOnPremises {
          value
          isHidden
        }
        daycareOnPremises {
          value
          isHidden
        }
        businessDescription {
          value
          isHidden
        }
        businessEmployeesOnPremises {
          value
          isHidden
        }
        visitorsInAMonth {
          value
          isHidden
        }
      }
      supplementalHeating {
        sourceOfHeat {
          value
          isHidden
        }
        sourceOfHeatInstallation {
          value
          isHidden
        }
        typeOfFuel {
          value
          isHidden
        }
        pleaseDescribe {
          value
          isHidden
        }
      }
      swimmingPool {
        swimmingPool {
          value
          isHidden
        }
        fourFeetFence {
          value
          isHidden
        }
        divingBoard {
          value
          isHidden
        }
        divingBoardSlideLiabilityExtension {
          value
          isHidden
        }
      }
      mortgage {
        value
        isHidden
      }
      propertyWithFireProtection {
        value
        isHidden
      }
      stormMitigationFortified {
        isHidden
        value
      }
      stormMitigationImpactglass {
        isHidden
        value
      }
      stormMitigationShutters {
        isHidden
        value
      }
      secureRails {
        value
        isHidden
      }
      thermoStaticControl {
        value
        isHidden
      }
      trampoline {
        trampolineLiability {
          value
          isHidden
        }
        trampolineSafetyNet {
          value
          isHidden
        }
        trampolineLiabilityExtension {
          value
          isHidden
        }
      }
      unitIsTied {
        value
        isHidden
      }
      unrepairedDamages {
        value
        isHidden
      }
      utilityServices {
        value
        isHidden
      }
      wroughtIron {
        value
        isHidden
      }
    }
    unitLevelUnderwritingQuestions {
      fieldName
      default
      options
    }
    ...BasicUnitDetailsWithUnitLevelCoveragesFragment
  }
  ${BasicUnitDetailsWithUnitLevelCoveragesFragmentFragmentDoc}
`;
export const NewBusinessPolicyWithUwQuestionsFragmentDoc = gql `
  fragment NewBusinessPolicyWithUWQuestions on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    policyLevelUnderwritingAnswers {
      animalBite
      conviction
      cancellationRenew {
        cancellationRenew
        reasonCancellationRenew
      }
    }
    units {
      ...BasicUnitDetailsWithUWQuestionsFragment
    }
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${BasicUnitDetailsWithUwQuestionsFragmentFragmentDoc}
`;
export const NewBusinessPolicyWithPriorClaimsFragmentFragmentDoc = gql `
  fragment NewBusinessPolicyWithPriorClaimsFragment on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    previousAddress {
      ...AddressFragment
    }
    priorClaims {
      fieldGroupLocator
      amount
      subjects {
        firstName
        lastName
      }
      source
      category
      date
      catastrophe
    }
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
`;
export const NewBusinessPolicyAfterQuoteSelectionFragmentFragmentDoc = gql `
  fragment NewBusinessPolicyAfterQuoteSelectionFragment on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    policyLevelUnderwritingAnswers {
      animalBite
      conviction
      cancellationRenew {
        cancellationRenew
        reasonCancellationRenew
      }
    }
    ...PolicyLevelCoveragesFragment
    units {
      ...BasicUnitDetailsWithUWQuestionsFragment
      selectedPlan
    }
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${PolicyLevelCoveragesFragmentFragmentDoc}
  ${BasicUnitDetailsWithUwQuestionsFragmentFragmentDoc}
`;
export const PolicySelectedQuotePricingFragmentDoc = gql `
  fragment PolicySelectedQuotePricing on Policy {
    selectedQuotePricing {
      ...PricingFragment
    }
  }
  ${PricingFragmentFragmentDoc}
`;
export const NewBusinessPolicySummaryFragmentFragmentDoc = gql `
  fragment NewBusinessPolicySummaryFragment on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    ...PolicyOffersFragment
    ...PolicySelectedQuotePricing
    previousAddress {
      ...AddressFragment
    }
    internalTrackingSubcode
    priorClaims {
      fieldGroupLocator
      amount
      subjects {
        firstName
        lastName
      }
      source
      category
      date
      catastrophe
    }
    policyholder {
      ...PolicyholderFragment
      hasActivePolicies
    }
    ...PolicyLevelCoveragesFragment
    units {
      ...BasicUnitDetailsWithUnitLevelCoveragesFragment
    }
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${PolicyOffersFragmentFragmentDoc}
  ${PolicySelectedQuotePricingFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${PolicyholderFragmentFragmentDoc}
  ${PolicyLevelCoveragesFragmentFragmentDoc}
  ${BasicUnitDetailsWithUnitLevelCoveragesFragmentFragmentDoc}
`;
export const UnitDetailsAfterUpdatesFragmentDoc = gql `
  fragment UnitDetailsAfterUpdates on PolicyUnit {
    ...BasicUnitDetailsWithUWQuestionsFragment
  }
  ${BasicUnitDetailsWithUwQuestionsFragmentFragmentDoc}
`;
export const NewBusinessPolicyUpdatedByEditMyPlanFragmentFragmentDoc = gql `
  fragment NewBusinessPolicyUpdatedByEditMyPlanFragment on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    ...PolicyOffersFragment
    ...PolicySelectedQuotePricing
    previousAddress {
      ...AddressFragment
    }
    priorClaims {
      fieldGroupLocator
      amount
      subjects {
        firstName
        lastName
      }
      source
      category
      date
      catastrophe
    }
    policyholder {
      ...PolicyholderFragment
      hasActivePolicies
    }
    ...PolicyLevelCoveragesFragment
    units {
      ...UnitDetailsAfterUpdates
    }
    policyLevelUnderwritingAnswers {
      animalBite
      conviction
      cancellationRenew {
        cancellationRenew
        reasonCancellationRenew
      }
    }
    policyLevelUnderwritingQuestions {
      fieldName
      default
      options
    }
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${PolicyOffersFragmentFragmentDoc}
  ${PolicySelectedQuotePricingFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${PolicyholderFragmentFragmentDoc}
  ${PolicyLevelCoveragesFragmentFragmentDoc}
  ${UnitDetailsAfterUpdatesFragmentDoc}
`;
export const ContinueQuotePolicyFragmentFragmentDoc = gql `
  fragment ContinueQuotePolicyFragment on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    ...PolicyOffersFragment
    ...PolicySelectedQuotePricing
    bookConversion {
      source
      previousPolicyId
    }
    startDateAfterUWReview
    productTypeName
    mainUnitType
    gotInsuranceScoreHit
    insuredDateOfBirth
    internalTrackingSubcode
    isEsigned
    isAgentsSignResponsibility
    isInternalAgency
    physicallyMailDocuments
    hasAnotherCoverTreePolicy
    hasAutoPolicy
    additionalInsured {
      adFirstName
      adLastName
      locator
      relationshipIndividual
    }
    priorInsuranceDetails {
      priorInsurance
      priorCarrierName
      priorPolicyExpirationDate
    }
    documents {
      ...DocumentFragment
    }
    previousAddress {
      ...AddressFragment
    }
    priorClaims {
      fieldGroupLocator
      amount
      subjects {
        firstName
        lastName
      }
      source
      category
      date
      catastrophe
    }
    policyholder {
      ...PolicyholderFragment
      hasActivePolicies
    }
    ...PolicyLevelCoveragesFragment
    units {
      ...UnitDetailsFragment
    }
    policyLevelUnderwritingAnswers {
      animalBite
      conviction
      cancellationRenew {
        cancellationRenew
        reasonCancellationRenew
      }
    }
    policyLevelUnderwritingQuestions {
      fieldName
      default
      options
    }
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${PolicyOffersFragmentFragmentDoc}
  ${PolicySelectedQuotePricingFragmentDoc}
  ${DocumentFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${PolicyholderFragmentFragmentDoc}
  ${PolicyLevelCoveragesFragmentFragmentDoc}
  ${UnitDetailsFragmentFragmentDoc}
`;
export const NewBusinessPolicyWithInternalTrackingSubcodeFragmentDoc = gql `
  fragment NewBusinessPolicyWithInternalTrackingSubcode on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    internalTrackingSubcode
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
`;
export const UnderwritingStatusFragmentFragmentDoc = gql `
  fragment UnderwritingStatusFragment on UnderwritingStatus {
    decision
    notes
    decisionTimestamp
  }
`;
export const PaymentPlanFragmentFragmentDoc = gql `
  fragment PaymentPlanFragment on PaymentPlan {
    isAvailable
    discountRate
    pricing {
      ...PricingFragment
    }
    installments {
      dueDate
      fees
      premium
      taxes
    }
  }
  ${PricingFragmentFragmentDoc}
`;
export const ContinueQuoteDocument = gql `
  mutation ContinueQuote($policyLocator: ID!, $effectiveDate: AWSDate) {
    continueQuote(
      policyLocator: $policyLocator
      effectiveDate: $effectiveDate
    ) {
      ... on ContinueQuoteResponse {
        policy {
          ...ContinueQuotePolicyFragment
        }
        dynamicQuestions {
          basicPolicyQuestions {
            fieldName
            label
            tooltip
          }
          priorClaimsQuestions {
            label
            fieldName
            type
            options
            visibleOnPickedOptions
          }
        }
      }
      ... on ContinueQuoteBlocked {
        canContinueQuote
      }
    }
  }
  ${ContinueQuotePolicyFragmentFragmentDoc}
`;
/**
 * __useContinueQuoteMutation__
 *
 * To run a mutation, you first call `useContinueQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContinueQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [continueQuoteMutation, { data, loading, error }] = useContinueQuoteMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      effectiveDate: // value for 'effectiveDate'
 *   },
 * });
 */
export function useContinueQuoteMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(ContinueQuoteDocument, options);
}
export const CheckEndorsementEligibilityDocument = gql `
  query CheckEndorsementEligibility($policyLocator: ID!) {
    checkEndorsementEligibility(policyLocator: $policyLocator) {
      isEligible
      reason
      minEffectiveDate
      maxEffectiveDate
    }
  }
`;
/**
 * __useCheckEndorsementEligibilityQuery__
 *
 * To run a query within a React component, call `useCheckEndorsementEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEndorsementEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEndorsementEligibilityQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useCheckEndorsementEligibilityQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(CheckEndorsementEligibilityDocument, options);
}
export function useCheckEndorsementEligibilityLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(CheckEndorsementEligibilityDocument, options);
}
export function useCheckEndorsementEligibilitySuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(CheckEndorsementEligibilityDocument, options);
}
export const CheckEndorsementUnderwritingDocument = gql `
  query CheckEndorsementUnderwriting($endorsementLocator: ID!) {
    checkEndorsementUnderwriting(endorsementLocator: $endorsementLocator) {
      decision
      notes
      status
    }
  }
`;
/**
 * __useCheckEndorsementUnderwritingQuery__
 *
 * To run a query within a React component, call `useCheckEndorsementUnderwritingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEndorsementUnderwritingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEndorsementUnderwritingQuery({
 *   variables: {
 *      endorsementLocator: // value for 'endorsementLocator'
 *   },
 * });
 */
export function useCheckEndorsementUnderwritingQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(CheckEndorsementUnderwritingDocument, options);
}
export function useCheckEndorsementUnderwritingLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(CheckEndorsementUnderwritingDocument, options);
}
export function useCheckEndorsementUnderwritingSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(CheckEndorsementUnderwritingDocument, options);
}
export const CreateOrUpdateEndorsementDocument = gql `
  mutation CreateOrUpdateEndorsement($input: CreateOrUpdateEndorsementInput!) {
    createOrUpdateEndorsement(input: $input) {
      isSuccessful
      reason
      endorsementLocator
      status
      priceChange {
        premium
        taxes
        fees
      }
      projectedPolicy {
        additionalInsured {
          adFirstName
          adLastName
          locator
          relationshipIndividual
        }
        units {
          unitId
          address {
            streetAddress
            city
            state
            zipCode
            unitNumber
          }
          construction {
            homeType
            manufacturerName
            makeCustom
            modelHome
            roofYearYyyy
            roofShape
            roofCondition
            totalSquareFootage
            homeWidth
            homeLength
            modelYear
            homeHudNumber
            skirtingType
            homeFixtures
          }
          details {
            unitLocation
            communityName
          }
          unitLevelCoverages {
            ...EndorsementExtraCoverages
            ...UnitLevelBaseCoveragesFragment
          }
        }
        additionalInterests {
          ...AdditionalInterestFragmentWithBilling
        }
        ...PolicyLevelCoveragesFragment
        ...EndorsementUnderwriting
      }
    }
  }
  ${EndorsementExtraCoveragesFragmentDoc}
  ${UnitLevelBaseCoveragesFragmentFragmentDoc}
  ${AdditionalInterestFragmentWithBillingFragmentDoc}
  ${PolicyLevelCoveragesFragmentFragmentDoc}
  ${EndorsementUnderwritingFragmentDoc}
`;
/**
 * __useCreateOrUpdateEndorsementMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateEndorsementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateEndorsementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateEndorsementMutation, { data, loading, error }] = useCreateOrUpdateEndorsementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateEndorsementMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateOrUpdateEndorsementDocument, options);
}
export const DiscardEndorsementsDocument = gql `
  mutation DiscardEndorsements(
    $policyLocator: ID!
    $endorsementLocators: [ID!]
    $discardAllExceptSelected: Boolean
  ) {
    discardEndorsements(
      policyLocator: $policyLocator
      endorsementLocators: $endorsementLocators
      discardAllExceptSelected: $discardAllExceptSelected
    ) {
      policyLocator
      results {
        endorsementLocator
        status
        isSuccessful
        errorReason
      }
    }
  }
`;
/**
 * __useDiscardEndorsementsMutation__
 *
 * To run a mutation, you first call `useDiscardEndorsementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardEndorsementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardEndorsementsMutation, { data, loading, error }] = useDiscardEndorsementsMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      endorsementLocators: // value for 'endorsementLocators'
 *      discardAllExceptSelected: // value for 'discardAllExceptSelected'
 *   },
 * });
 */
export function useDiscardEndorsementsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DiscardEndorsementsDocument, options);
}
export const GetEndorsementDocument = gql `
  query GetEndorsement($policyLocator: ID!, $endorsementLocator: ID!) {
    getEndorsement(
      policyLocator: $policyLocator
      endorsementLocator: $endorsementLocator
    ) {
      endorsementLocator
      policyLocator
      effectiveDate
      reason
      status
      failureReason
      underwriting {
        decision
        notes
      }
      priceChange {
        premium
        taxes
        fees
      }
      projectedPolicy {
        additionalInsured {
          adFirstName
          adLastName
          locator
          relationshipIndividual
        }
        units {
          unitId
          address {
            streetAddress
            city
            state
            zipCode
            unitNumber
          }
          construction {
            homeType
            manufacturerName
            makeCustom
            modelHome
            roofYearYyyy
            roofShape
            roofCondition
            totalSquareFootage
            homeWidth
            homeLength
            modelYear
            homeHudNumber
            skirtingType
            homeFixtures
          }
          details {
            unitLocation
            communityName
          }
          unitLevelCoverages {
            ...EndorsementExtraCoverages
            ...UnitLevelBaseCoveragesFragment
          }
        }
        additionalInterests {
          ...AdditionalInterestFragmentWithBilling
        }
        ...PolicyLevelCoveragesFragment
        ...EndorsementUnderwriting
      }
    }
  }
  ${EndorsementExtraCoveragesFragmentDoc}
  ${UnitLevelBaseCoveragesFragmentFragmentDoc}
  ${AdditionalInterestFragmentWithBillingFragmentDoc}
  ${PolicyLevelCoveragesFragmentFragmentDoc}
  ${EndorsementUnderwritingFragmentDoc}
`;
/**
 * __useGetEndorsementQuery__
 *
 * To run a query within a React component, call `useGetEndorsementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndorsementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndorsementQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      endorsementLocator: // value for 'endorsementLocator'
 *   },
 * });
 */
export function useGetEndorsementQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetEndorsementDocument, options);
}
export function useGetEndorsementLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetEndorsementDocument, options);
}
export function useGetEndorsementSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetEndorsementDocument, options);
}
export const IssueEndorsementDocument = gql `
  mutation IssueEndorsement($endorsementLocator: ID!) {
    issueEndorsement(endorsementLocator: $endorsementLocator) {
      endorsementLocator
      effectiveDate
      amount
    }
  }
`;
/**
 * __useIssueEndorsementMutation__
 *
 * To run a mutation, you first call `useIssueEndorsementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueEndorsementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueEndorsementMutation, { data, loading, error }] = useIssueEndorsementMutation({
 *   variables: {
 *      endorsementLocator: // value for 'endorsementLocator'
 *   },
 * });
 */
export function useIssueEndorsementMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(IssueEndorsementDocument, options);
}
export const GetOverviewMetricsDocument = gql `
  query GetOverviewMetrics($period: GetOverviewMetricsPeriod) {
    getOverviewMetrics(period: $period) {
      metrics {
        quotesAmount
        quotesAmountChange
        policiesAmount
        policiesAmountChange
        premium
        premiumChangePercent
        quoteToBindRatioPercent
        quoteToBindRatioPercentChange
      }
      period
    }
  }
`;
/**
 * __useGetOverviewMetricsQuery__
 *
 * To run a query within a React component, call `useGetOverviewMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverviewMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverviewMetricsQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetOverviewMetricsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetOverviewMetricsDocument, options);
}
export function useGetOverviewMetricsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetOverviewMetricsDocument, options);
}
export function useGetOverviewMetricsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetOverviewMetricsDocument, options);
}
export const GetOverviewMetricsWithoutDetailedDataDocument = gql `
  query GetOverviewMetricsWithoutDetailedData(
    $period: GetOverviewMetricsPeriod
  ) {
    getOverviewMetrics(period: $period) {
      metrics {
        quotesAmount
        quotesAmountChange
        policiesAmount
        policiesAmountChange
      }
      period
    }
  }
`;
/**
 * __useGetOverviewMetricsWithoutDetailedDataQuery__
 *
 * To run a query within a React component, call `useGetOverviewMetricsWithoutDetailedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverviewMetricsWithoutDetailedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverviewMetricsWithoutDetailedDataQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetOverviewMetricsWithoutDetailedDataQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetOverviewMetricsWithoutDetailedDataDocument, options);
}
export function useGetOverviewMetricsWithoutDetailedDataLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetOverviewMetricsWithoutDetailedDataDocument, options);
}
export function useGetOverviewMetricsWithoutDetailedDataSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetOverviewMetricsWithoutDetailedDataDocument, options);
}
export const CanOperateInStateDocument = gql `
  query CanOperateInState($state: String!) {
    canOperateInState(state: $state)
  }
`;
/**
 * __useCanOperateInStateQuery__
 *
 * To run a query within a React component, call `useCanOperateInStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanOperateInStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanOperateInStateQuery({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useCanOperateInStateQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(CanOperateInStateDocument, options);
}
export function useCanOperateInStateLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(CanOperateInStateDocument, options);
}
export function useCanOperateInStateSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(CanOperateInStateDocument, options);
}
export const ChangePolicyDefaultStripePaymentMethodDocument = gql `
  mutation ChangePolicyDefaultStripePaymentMethod(
    $policyLocator: ID!
    $paymentMethodId: ID!
  ) {
    changePolicyDefaultStripePaymentMethod(
      policyLocator: $policyLocator
      paymentMethodId: $paymentMethodId
    ) {
      ...PolicyWithPaymentMethods
      renewals {
        ...RenewalWithCheckReceival
      }
    }
  }
  ${PolicyWithPaymentMethodsFragmentDoc}
  ${RenewalWithCheckReceivalFragmentDoc}
`;
/**
 * __useChangePolicyDefaultStripePaymentMethodMutation__
 *
 * To run a mutation, you first call `useChangePolicyDefaultStripePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePolicyDefaultStripePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePolicyDefaultStripePaymentMethodMutation, { data, loading, error }] = useChangePolicyDefaultStripePaymentMethodMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useChangePolicyDefaultStripePaymentMethodMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(ChangePolicyDefaultStripePaymentMethodDocument, options);
}
export const CreatePolicyStripePaymentMethodSetupIntentDocument = gql `
  mutation CreatePolicyStripePaymentMethodSetupIntent($policyLocator: ID!) {
    createPolicyStripePaymentMethodSetupIntent(policyLocator: $policyLocator) {
      clientSecret
    }
  }
`;
/**
 * __useCreatePolicyStripePaymentMethodSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreatePolicyStripePaymentMethodSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePolicyStripePaymentMethodSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPolicyStripePaymentMethodSetupIntentMutation, { data, loading, error }] = useCreatePolicyStripePaymentMethodSetupIntentMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useCreatePolicyStripePaymentMethodSetupIntentMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreatePolicyStripePaymentMethodSetupIntentDocument, options);
}
export const RemovePolicyStripePaymentMethodDocument = gql `
  mutation RemovePolicyStripePaymentMethod(
    $policyLocator: ID!
    $paymentMethodId: ID!
  ) {
    removePolicyStripePaymentMethod(
      policyLocator: $policyLocator
      paymentMethodId: $paymentMethodId
    ) {
      ...PolicyWithPaymentMethods
    }
  }
  ${PolicyWithPaymentMethodsFragmentDoc}
`;
/**
 * __useRemovePolicyStripePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemovePolicyStripePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePolicyStripePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePolicyStripePaymentMethodMutation, { data, loading, error }] = useRemovePolicyStripePaymentMethodMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useRemovePolicyStripePaymentMethodMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RemovePolicyStripePaymentMethodDocument, options);
}
export const GetPendingCancellationPolicyListItemsDocument = gql `
  query GetPendingCancellationPolicyListItems(
    $pagination: PaginationInput
    $sorting: GetPolicySortInput
    $filter: GetPendingCancellationPolicyFilterInput
  ) {
    getPendingCancellationPolicyListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...PendingCancellationPolicyListItem
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${PendingCancellationPolicyListItemFragmentDoc}
`;
/**
 * __useGetPendingCancellationPolicyListItemsQuery__
 *
 * To run a query within a React component, call `useGetPendingCancellationPolicyListItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingCancellationPolicyListItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingCancellationPolicyListItemsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPendingCancellationPolicyListItemsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPendingCancellationPolicyListItemsDocument, options);
}
export function useGetPendingCancellationPolicyListItemsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPendingCancellationPolicyListItemsDocument, options);
}
export function useGetPendingCancellationPolicyListItemsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPendingCancellationPolicyListItemsDocument, options);
}
export const GetPendingCancellationPolicyListItemsWithoutAgencyNameDocument = gql `
  query GetPendingCancellationPolicyListItemsWithoutAgencyName(
    $pagination: PaginationInput
    $sorting: GetPolicySortInput
    $filter: GetPendingCancellationPolicyFilterInput
  ) {
    getPendingCancellationPolicyListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...PendingCancellationPolicyListItemWithoutAgencyName
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${PendingCancellationPolicyListItemWithoutAgencyNameFragmentDoc}
`;
/**
 * __useGetPendingCancellationPolicyListItemsWithoutAgencyNameQuery__
 *
 * To run a query within a React component, call `useGetPendingCancellationPolicyListItemsWithoutAgencyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingCancellationPolicyListItemsWithoutAgencyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingCancellationPolicyListItemsWithoutAgencyNameQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPendingCancellationPolicyListItemsWithoutAgencyNameQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPendingCancellationPolicyListItemsWithoutAgencyNameDocument, options);
}
export function useGetPendingCancellationPolicyListItemsWithoutAgencyNameLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPendingCancellationPolicyListItemsWithoutAgencyNameDocument, options);
}
export function useGetPendingCancellationPolicyListItemsWithoutAgencyNameSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPendingCancellationPolicyListItemsWithoutAgencyNameDocument, options);
}
export const GetPendingCancellationPolicyListItemsWithoutAgencyDataDocument = gql `
  query GetPendingCancellationPolicyListItemsWithoutAgencyData(
    $pagination: PaginationInput
    $sorting: GetPolicySortInput
    $filter: GetPendingCancellationPolicyFilterInput
  ) {
    getPendingCancellationPolicyListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...PendingCancellationPolicyListItemWithoutAgencyData
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${PendingCancellationPolicyListItemWithoutAgencyDataFragmentDoc}
`;
/**
 * __useGetPendingCancellationPolicyListItemsWithoutAgencyDataQuery__
 *
 * To run a query within a React component, call `useGetPendingCancellationPolicyListItemsWithoutAgencyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingCancellationPolicyListItemsWithoutAgencyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingCancellationPolicyListItemsWithoutAgencyDataQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPendingCancellationPolicyListItemsWithoutAgencyDataQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPendingCancellationPolicyListItemsWithoutAgencyDataDocument, options);
}
export function useGetPendingCancellationPolicyListItemsWithoutAgencyDataLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPendingCancellationPolicyListItemsWithoutAgencyDataDocument, options);
}
export function useGetPendingCancellationPolicyListItemsWithoutAgencyDataSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPendingCancellationPolicyListItemsWithoutAgencyDataDocument, options);
}
export const ValidatePolicyForAdditionalInterestDocument = gql `
  query ValidatePolicyForAdditionalInterest($policyLocator: ID!) {
    validatePolicyForAdditionalInterest(policyLocator: $policyLocator) {
      isSuccessful
      reason
    }
  }
`;
/**
 * __useValidatePolicyForAdditionalInterestQuery__
 *
 * To run a query within a React component, call `useValidatePolicyForAdditionalInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePolicyForAdditionalInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePolicyForAdditionalInterestQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useValidatePolicyForAdditionalInterestQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ValidatePolicyForAdditionalInterestDocument, options);
}
export function useValidatePolicyForAdditionalInterestLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ValidatePolicyForAdditionalInterestDocument, options);
}
export function useValidatePolicyForAdditionalInterestSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(ValidatePolicyForAdditionalInterestDocument, options);
}
export const AddAdditionalInterestDocument = gql `
  mutation AddAdditionalInterest(
    $policyLocator: ID!
    $additionalInterest: NonBillingAdditionalInterestInput!
  ) {
    addAdditionalInterest(
      policyLocator: $policyLocator
      additionalInterest: $additionalInterest
    ) {
      isSuccessful
      reason
      isOfferSent
      isRenewalActive
    }
  }
`;
/**
 * __useAddAdditionalInterestMutation__
 *
 * To run a mutation, you first call `useAddAdditionalInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdditionalInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdditionalInterestMutation, { data, loading, error }] = useAddAdditionalInterestMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      additionalInterest: // value for 'additionalInterest'
 *   },
 * });
 */
export function useAddAdditionalInterestMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(AddAdditionalInterestDocument, options);
}
export const EditOrReplaceAdditionalInterestDocument = gql `
  mutation EditOrReplaceAdditionalInterest(
    $policyLocator: ID!
    $additionalInterestId: ID!
    $operationType: EditOrReplaceOperationType!
    $additionalInterest: NonBillingAdditionalInterestInput!
  ) {
    editOrReplaceAdditionalInterest(
      policyLocator: $policyLocator
      additionalInterestId: $additionalInterestId
      operationType: $operationType
      additionalInterest: $additionalInterest
    ) {
      isSuccessful
      reason
      isOfferSent
      isRenewalActive
    }
  }
`;
/**
 * __useEditOrReplaceAdditionalInterestMutation__
 *
 * To run a mutation, you first call `useEditOrReplaceAdditionalInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrReplaceAdditionalInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrReplaceAdditionalInterestMutation, { data, loading, error }] = useEditOrReplaceAdditionalInterestMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      additionalInterestId: // value for 'additionalInterestId'
 *      operationType: // value for 'operationType'
 *      additionalInterest: // value for 'additionalInterest'
 *   },
 * });
 */
export function useEditOrReplaceAdditionalInterestMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(EditOrReplaceAdditionalInterestDocument, options);
}
export const RemoveAdditionalInterestDocument = gql `
  mutation RemoveAdditionalInterest(
    $policyLocator: ID!
    $additionalInterestId: ID!
  ) {
    removeAdditionalInterest(
      policyLocator: $policyLocator
      additionalInterestId: $additionalInterestId
    ) {
      isSuccessful
      reason
      isOfferSent
      isRenewalActive
    }
  }
`;
/**
 * __useRemoveAdditionalInterestMutation__
 *
 * To run a mutation, you first call `useRemoveAdditionalInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdditionalInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdditionalInterestMutation, { data, loading, error }] = useRemoveAdditionalInterestMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      additionalInterestId: // value for 'additionalInterestId'
 *   },
 * });
 */
export function useRemoveAdditionalInterestMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RemoveAdditionalInterestDocument, options);
}
export const CreatePolicyNoteDocument = gql `
  mutation CreatePolicyNote($policyLocator: ID!, $content: String!) {
    createPolicyNote(content: $content, policyLocator: $policyLocator) {
      ...PolicyWithNotes
    }
  }
  ${PolicyWithNotesFragmentDoc}
`;
/**
 * __useCreatePolicyNoteMutation__
 *
 * To run a mutation, you first call `useCreatePolicyNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePolicyNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPolicyNoteMutation, { data, loading, error }] = useCreatePolicyNoteMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreatePolicyNoteMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreatePolicyNoteDocument, options);
}
export const OnCreatePolicyNoteDocument = gql `
  subscription OnCreatePolicyNote($policyLocator: ID!) {
    onCreatePolicyNote(policyLocator: $policyLocator) {
      ...PolicyWithNotes
    }
  }
  ${PolicyWithNotesFragmentDoc}
`;
/**
 * __useOnCreatePolicyNoteSubscription__
 *
 * To run a query within a React component, call `useOnCreatePolicyNoteSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreatePolicyNoteSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreatePolicyNoteSubscription({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useOnCreatePolicyNoteSubscription(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSubscription(OnCreatePolicyNoteDocument, options);
}
export const GetPolicyDocument = gql `
  query GetPolicy($policyLocator: ID!) {
    getPolicy(policyLocator: $policyLocator) {
      ...PolicyBase
    }
  }
  ${PolicyBaseFragmentDoc}
`;
/**
 * __useGetPolicyQuery__
 *
 * To run a query within a React component, call `useGetPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useGetPolicyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPolicyDocument, options);
}
export function useGetPolicyLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPolicyDocument, options);
}
export function useGetPolicySuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPolicyDocument, options);
}
export const GetPolicyWithAgentNameDocument = gql `
  query GetPolicyWithAgentName($policyLocator: ID!) {
    getPolicy(policyLocator: $policyLocator) {
      ...PolicyWithAgentName
    }
  }
  ${PolicyWithAgentNameFragmentDoc}
`;
/**
 * __useGetPolicyWithAgentNameQuery__
 *
 * To run a query within a React component, call `useGetPolicyWithAgentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyWithAgentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyWithAgentNameQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useGetPolicyWithAgentNameQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPolicyWithAgentNameDocument, options);
}
export function useGetPolicyWithAgentNameLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPolicyWithAgentNameDocument, options);
}
export function useGetPolicyWithAgentNameSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPolicyWithAgentNameDocument, options);
}
export const GetPolicyWithAgencyDataDocument = gql `
  query GetPolicyWithAgencyData($policyLocator: ID!) {
    getPolicy(policyLocator: $policyLocator) {
      ...PolicyWithAgencyData
    }
  }
  ${PolicyWithAgencyDataFragmentDoc}
`;
/**
 * __useGetPolicyWithAgencyDataQuery__
 *
 * To run a query within a React component, call `useGetPolicyWithAgencyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyWithAgencyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyWithAgencyDataQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useGetPolicyWithAgencyDataQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPolicyWithAgencyDataDocument, options);
}
export function useGetPolicyWithAgencyDataLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPolicyWithAgencyDataDocument, options);
}
export function useGetPolicyWithAgencyDataSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPolicyWithAgencyDataDocument, options);
}
export const GetPolicyWithCheckReceivalDataDocument = gql `
  query GetPolicyWithCheckReceivalData($policyLocator: ID!) {
    getPolicy(policyLocator: $policyLocator) {
      ...PolicyWithCheckReceivalData
    }
  }
  ${PolicyWithCheckReceivalDataFragmentDoc}
`;
/**
 * __useGetPolicyWithCheckReceivalDataQuery__
 *
 * To run a query within a React component, call `useGetPolicyWithCheckReceivalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyWithCheckReceivalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyWithCheckReceivalDataQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useGetPolicyWithCheckReceivalDataQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPolicyWithCheckReceivalDataDocument, options);
}
export function useGetPolicyWithCheckReceivalDataLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPolicyWithCheckReceivalDataDocument, options);
}
export function useGetPolicyWithCheckReceivalDataSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPolicyWithCheckReceivalDataDocument, options);
}
export const GetPolicyWithDocumentsDocument = gql `
  query GetPolicyWithDocuments($policyLocator: ID!) {
    getPolicy(policyLocator: $policyLocator) {
      ...PolicyWithDocuments
    }
  }
  ${PolicyWithDocumentsFragmentDoc}
`;
/**
 * __useGetPolicyWithDocumentsQuery__
 *
 * To run a query within a React component, call `useGetPolicyWithDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyWithDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyWithDocumentsQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useGetPolicyWithDocumentsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPolicyWithDocumentsDocument, options);
}
export function useGetPolicyWithDocumentsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPolicyWithDocumentsDocument, options);
}
export function useGetPolicyWithDocumentsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPolicyWithDocumentsDocument, options);
}
export const GetPolicyWithPaymentMethodsDocument = gql `
  query GetPolicyWithPaymentMethods($policyLocator: ID!) {
    getPolicy(policyLocator: $policyLocator) {
      ...PolicyWithPaymentMethods
    }
  }
  ${PolicyWithPaymentMethodsFragmentDoc}
`;
/**
 * __useGetPolicyWithPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetPolicyWithPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyWithPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyWithPaymentMethodsQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useGetPolicyWithPaymentMethodsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPolicyWithPaymentMethodsDocument, options);
}
export function useGetPolicyWithPaymentMethodsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPolicyWithPaymentMethodsDocument, options);
}
export function useGetPolicyWithPaymentMethodsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPolicyWithPaymentMethodsDocument, options);
}
export const GetPolicyWithStartDateAfterUwReviewDocument = gql `
  query GetPolicyWithStartDateAfterUWReview($policyLocator: ID!) {
    getPolicy(policyLocator: $policyLocator) {
      ...PolicyWithStartDateAfterUWReview
    }
  }
  ${PolicyWithStartDateAfterUwReviewFragmentDoc}
`;
/**
 * __useGetPolicyWithStartDateAfterUwReviewQuery__
 *
 * To run a query within a React component, call `useGetPolicyWithStartDateAfterUwReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyWithStartDateAfterUwReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyWithStartDateAfterUwReviewQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useGetPolicyWithStartDateAfterUwReviewQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPolicyWithStartDateAfterUwReviewDocument, options);
}
export function useGetPolicyWithStartDateAfterUwReviewLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPolicyWithStartDateAfterUwReviewDocument, options);
}
export function useGetPolicyWithStartDateAfterUwReviewSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPolicyWithStartDateAfterUwReviewDocument, options);
}
export const GetPolicyWithUwResultDocument = gql `
  query GetPolicyWithUWResult($policyLocator: ID!) {
    getPolicy(policyLocator: $policyLocator) {
      ...PolicyWithUWResult
    }
  }
  ${PolicyWithUwResultFragmentDoc}
`;
/**
 * __useGetPolicyWithUwResultQuery__
 *
 * To run a query within a React component, call `useGetPolicyWithUwResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyWithUwResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyWithUwResultQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useGetPolicyWithUwResultQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPolicyWithUwResultDocument, options);
}
export function useGetPolicyWithUwResultLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPolicyWithUwResultDocument, options);
}
export function useGetPolicyWithUwResultSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPolicyWithUwResultDocument, options);
}
export const GetPolicyListItemsDocument = gql `
  query GetPolicyListItems(
    $pagination: PaginationInput
    $sorting: GetPolicySortInput
    $filter: GetPolicyFilterInput
  ) {
    getPolicyListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...PolicyListItem
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${PolicyListItemFragmentDoc}
`;
/**
 * __useGetPolicyListItemsQuery__
 *
 * To run a query within a React component, call `useGetPolicyListItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyListItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyListItemsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPolicyListItemsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPolicyListItemsDocument, options);
}
export function useGetPolicyListItemsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPolicyListItemsDocument, options);
}
export function useGetPolicyListItemsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPolicyListItemsDocument, options);
}
export const GetPolicyListItemsWithoutAgencyNameDocument = gql `
  query GetPolicyListItemsWithoutAgencyName(
    $pagination: PaginationInput
    $sorting: GetPolicySortInput
    $filter: GetPolicyFilterInput
  ) {
    getPolicyListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...PolicyListItemWithoutAgencyName
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${PolicyListItemWithoutAgencyNameFragmentDoc}
`;
/**
 * __useGetPolicyListItemsWithoutAgencyNameQuery__
 *
 * To run a query within a React component, call `useGetPolicyListItemsWithoutAgencyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyListItemsWithoutAgencyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyListItemsWithoutAgencyNameQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPolicyListItemsWithoutAgencyNameQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPolicyListItemsWithoutAgencyNameDocument, options);
}
export function useGetPolicyListItemsWithoutAgencyNameLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPolicyListItemsWithoutAgencyNameDocument, options);
}
export function useGetPolicyListItemsWithoutAgencyNameSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPolicyListItemsWithoutAgencyNameDocument, options);
}
export const GetPolicyListItemsWithoutAgencyDataDocument = gql `
  query GetPolicyListItemsWithoutAgencyData(
    $pagination: PaginationInput
    $sorting: GetPolicySortInput
    $filter: GetPolicyFilterInput
  ) {
    getPolicyListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...PolicyListItemWithoutAgencyData
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${PolicyListItemWithoutAgencyDataFragmentDoc}
`;
/**
 * __useGetPolicyListItemsWithoutAgencyDataQuery__
 *
 * To run a query within a React component, call `useGetPolicyListItemsWithoutAgencyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyListItemsWithoutAgencyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyListItemsWithoutAgencyDataQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPolicyListItemsWithoutAgencyDataQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPolicyListItemsWithoutAgencyDataDocument, options);
}
export function useGetPolicyListItemsWithoutAgencyDataLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPolicyListItemsWithoutAgencyDataDocument, options);
}
export function useGetPolicyListItemsWithoutAgencyDataSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPolicyListItemsWithoutAgencyDataDocument, options);
}
export const GetQuoteListItemsDocument = gql `
  query GetQuoteListItems(
    $pagination: PaginationInput
    $sorting: GetQuoteSortInput
    $filter: GetQuoteFilterInput
  ) {
    getQuoteListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...QuoteListItem
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${QuoteListItemFragmentDoc}
`;
/**
 * __useGetQuoteListItemsQuery__
 *
 * To run a query within a React component, call `useGetQuoteListItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteListItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteListItemsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetQuoteListItemsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetQuoteListItemsDocument, options);
}
export function useGetQuoteListItemsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetQuoteListItemsDocument, options);
}
export function useGetQuoteListItemsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetQuoteListItemsDocument, options);
}
export const GetQuoteListItemsWithoutAgencyNameDocument = gql `
  query GetQuoteListItemsWithoutAgencyName(
    $pagination: PaginationInput
    $sorting: GetQuoteSortInput
    $filter: GetQuoteFilterInput
  ) {
    getQuoteListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...QuoteListItemWithoutAgencyName
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${QuoteListItemWithoutAgencyNameFragmentDoc}
`;
/**
 * __useGetQuoteListItemsWithoutAgencyNameQuery__
 *
 * To run a query within a React component, call `useGetQuoteListItemsWithoutAgencyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteListItemsWithoutAgencyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteListItemsWithoutAgencyNameQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetQuoteListItemsWithoutAgencyNameQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetQuoteListItemsWithoutAgencyNameDocument, options);
}
export function useGetQuoteListItemsWithoutAgencyNameLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetQuoteListItemsWithoutAgencyNameDocument, options);
}
export function useGetQuoteListItemsWithoutAgencyNameSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetQuoteListItemsWithoutAgencyNameDocument, options);
}
export const GetQuoteListItemsWithoutAgencyDataDocument = gql `
  query GetQuoteListItemsWithoutAgencyData(
    $pagination: PaginationInput
    $sorting: GetQuoteSortInput
    $filter: GetQuoteFilterInput
  ) {
    getQuoteListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...QuoteListItemWithoutAgencyData
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${QuoteListItemWithoutAgencyDataFragmentDoc}
`;
/**
 * __useGetQuoteListItemsWithoutAgencyDataQuery__
 *
 * To run a query within a React component, call `useGetQuoteListItemsWithoutAgencyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteListItemsWithoutAgencyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteListItemsWithoutAgencyDataQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetQuoteListItemsWithoutAgencyDataQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetQuoteListItemsWithoutAgencyDataDocument, options);
}
export function useGetQuoteListItemsWithoutAgencyDataLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetQuoteListItemsWithoutAgencyDataDocument, options);
}
export function useGetQuoteListItemsWithoutAgencyDataSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetQuoteListItemsWithoutAgencyDataDocument, options);
}
export const RemoveDocumentFromPolicyDocument = gql `
  mutation RemoveDocumentFromPolicy(
    $policyLocator: ID!
    $documentLocator: ID!
  ) {
    removeDocumentFromPolicy(
      policyLocator: $policyLocator
      documentLocator: $documentLocator
    ) {
      ...PolicyWithDocuments
    }
  }
  ${PolicyWithDocumentsFragmentDoc}
`;
/**
 * __useRemoveDocumentFromPolicyMutation__
 *
 * To run a mutation, you first call `useRemoveDocumentFromPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDocumentFromPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDocumentFromPolicyMutation, { data, loading, error }] = useRemoveDocumentFromPolicyMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      documentLocator: // value for 'documentLocator'
 *   },
 * });
 */
export function useRemoveDocumentFromPolicyMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RemoveDocumentFromPolicyDocument, options);
}
export const SendBulkEsignRemindersDocument = gql `
  mutation SendBulkEsignReminders($policyholderLocator: ID!) {
    sendBulkEsignReminders(policyholderLocator: $policyholderLocator) {
      policyLocator
      esignReminderStatus
      message
    }
  }
`;
/**
 * __useSendBulkEsignRemindersMutation__
 *
 * To run a mutation, you first call `useSendBulkEsignRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBulkEsignRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBulkEsignRemindersMutation, { data, loading, error }] = useSendBulkEsignRemindersMutation({
 *   variables: {
 *      policyholderLocator: // value for 'policyholderLocator'
 *   },
 * });
 */
export function useSendBulkEsignRemindersMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SendBulkEsignRemindersDocument, options);
}
export const SendEsignReminderDocument = gql `
  mutation SendEsignReminder($policyLocator: ID!) {
    sendEsignReminder(policyLocator: $policyLocator) {
      policyLocator
      esignReminderStatus
      message
    }
  }
`;
/**
 * __useSendEsignReminderMutation__
 *
 * To run a mutation, you first call `useSendEsignReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEsignReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEsignReminderMutation, { data, loading, error }] = useSendEsignReminderMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useSendEsignReminderMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SendEsignReminderDocument, options);
}
export const DiscardRenewalDocument = gql `
  mutation DiscardRenewal($renewalLocator: ID!, $reason: String!) {
    discardRenewal(renewalLocator: $renewalLocator, reason: $reason) {
      renewalLocator
      status
      discardedDate
      discardedBy
      description
      updatedDate
    }
  }
`;
/**
 * __useDiscardRenewalMutation__
 *
 * To run a mutation, you first call `useDiscardRenewalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardRenewalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardRenewalMutation, { data, loading, error }] = useDiscardRenewalMutation({
 *   variables: {
 *      renewalLocator: // value for 'renewalLocator'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDiscardRenewalMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DiscardRenewalDocument, options);
}
export const EditCheckReceivalDescriptionDocument = gql `
  mutation EditCheckReceivalDescription(
    $renewalLocator: ID!
    $description: String
  ) {
    editCheckReceivalDescription(
      renewalLocator: $renewalLocator
      description: $description
    ) {
      ...RenewalWithCheckReceival
    }
  }
  ${RenewalWithCheckReceivalFragmentDoc}
`;
/**
 * __useEditCheckReceivalDescriptionMutation__
 *
 * To run a mutation, you first call `useEditCheckReceivalDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCheckReceivalDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCheckReceivalDescriptionMutation, { data, loading, error }] = useEditCheckReceivalDescriptionMutation({
 *   variables: {
 *      renewalLocator: // value for 'renewalLocator'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useEditCheckReceivalDescriptionMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(EditCheckReceivalDescriptionDocument, options);
}
export const GetRenewalDocument = gql `
  query GetRenewal($renewalLocator: ID!) {
    getRenewal(renewalLocator: $renewalLocator) {
      ...RenewalBase
    }
  }
  ${RenewalBaseFragmentDoc}
`;
/**
 * __useGetRenewalQuery__
 *
 * To run a query within a React component, call `useGetRenewalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenewalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenewalQuery({
 *   variables: {
 *      renewalLocator: // value for 'renewalLocator'
 *   },
 * });
 */
export function useGetRenewalQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetRenewalDocument, options);
}
export function useGetRenewalLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetRenewalDocument, options);
}
export function useGetRenewalSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetRenewalDocument, options);
}
export const GetRenewalWithAgentNameDocument = gql `
  query GetRenewalWithAgentName($renewalLocator: ID!) {
    getRenewal(renewalLocator: $renewalLocator) {
      ...RenewalWithAgentName
    }
  }
  ${RenewalWithAgentNameFragmentDoc}
`;
/**
 * __useGetRenewalWithAgentNameQuery__
 *
 * To run a query within a React component, call `useGetRenewalWithAgentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenewalWithAgentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenewalWithAgentNameQuery({
 *   variables: {
 *      renewalLocator: // value for 'renewalLocator'
 *   },
 * });
 */
export function useGetRenewalWithAgentNameQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetRenewalWithAgentNameDocument, options);
}
export function useGetRenewalWithAgentNameLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetRenewalWithAgentNameDocument, options);
}
export function useGetRenewalWithAgentNameSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetRenewalWithAgentNameDocument, options);
}
export const GetRenewalWithAgencyDataDocument = gql `
  query GetRenewalWithAgencyData($renewalLocator: ID!) {
    getRenewal(renewalLocator: $renewalLocator) {
      ...RenewalWithAgencyData
    }
  }
  ${RenewalWithAgencyDataFragmentDoc}
`;
/**
 * __useGetRenewalWithAgencyDataQuery__
 *
 * To run a query within a React component, call `useGetRenewalWithAgencyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenewalWithAgencyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenewalWithAgencyDataQuery({
 *   variables: {
 *      renewalLocator: // value for 'renewalLocator'
 *   },
 * });
 */
export function useGetRenewalWithAgencyDataQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetRenewalWithAgencyDataDocument, options);
}
export function useGetRenewalWithAgencyDataLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetRenewalWithAgencyDataDocument, options);
}
export function useGetRenewalWithAgencyDataSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetRenewalWithAgencyDataDocument, options);
}
export const GetRenewalWithCheckReceivalDocument = gql `
  query GetRenewalWithCheckReceival($renewalLocator: ID!) {
    getRenewal(renewalLocator: $renewalLocator) {
      ...RenewalWithCheckReceival
    }
  }
  ${RenewalWithCheckReceivalFragmentDoc}
`;
/**
 * __useGetRenewalWithCheckReceivalQuery__
 *
 * To run a query within a React component, call `useGetRenewalWithCheckReceivalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenewalWithCheckReceivalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenewalWithCheckReceivalQuery({
 *   variables: {
 *      renewalLocator: // value for 'renewalLocator'
 *   },
 * });
 */
export function useGetRenewalWithCheckReceivalQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetRenewalWithCheckReceivalDocument, options);
}
export function useGetRenewalWithCheckReceivalLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetRenewalWithCheckReceivalDocument, options);
}
export function useGetRenewalWithCheckReceivalSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetRenewalWithCheckReceivalDocument, options);
}
export const GetRenewalWithOfferDocumentDocument = gql `
  query GetRenewalWithOfferDocument($renewalLocator: ID!) {
    getRenewal(renewalLocator: $renewalLocator) {
      renewalLocator
      offerDocument {
        createdTimestamp
        displayName
        documentLocator
        fileName
        policyModificationLocator
        type
        url
        urlExpirationTimestamp
      }
    }
  }
`;
/**
 * __useGetRenewalWithOfferDocumentQuery__
 *
 * To run a query within a React component, call `useGetRenewalWithOfferDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenewalWithOfferDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenewalWithOfferDocumentQuery({
 *   variables: {
 *      renewalLocator: // value for 'renewalLocator'
 *   },
 * });
 */
export function useGetRenewalWithOfferDocumentQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetRenewalWithOfferDocumentDocument, options);
}
export function useGetRenewalWithOfferDocumentLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetRenewalWithOfferDocumentDocument, options);
}
export function useGetRenewalWithOfferDocumentSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetRenewalWithOfferDocumentDocument, options);
}
export const GetRenewalListItemsDocument = gql `
  query GetRenewalListItems(
    $pagination: PaginationInput
    $sorting: GetRenewalSortInput
    $filter: GetRenewalFilterInput
  ) {
    getRenewalListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...RenewalListItem
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${RenewalListItemFragmentDoc}
`;
/**
 * __useGetRenewalListItemsQuery__
 *
 * To run a query within a React component, call `useGetRenewalListItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenewalListItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenewalListItemsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetRenewalListItemsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetRenewalListItemsDocument, options);
}
export function useGetRenewalListItemsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetRenewalListItemsDocument, options);
}
export function useGetRenewalListItemsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetRenewalListItemsDocument, options);
}
export const GetRenewalListItemsWithoutAgencyNameDocument = gql `
  query GetRenewalListItemsWithoutAgencyName(
    $pagination: PaginationInput
    $sorting: GetRenewalSortInput
    $filter: GetRenewalFilterInput
  ) {
    getRenewalListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...RenewalListItemWithoutAgencyName
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${RenewalListItemWithoutAgencyNameFragmentDoc}
`;
/**
 * __useGetRenewalListItemsWithoutAgencyNameQuery__
 *
 * To run a query within a React component, call `useGetRenewalListItemsWithoutAgencyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenewalListItemsWithoutAgencyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenewalListItemsWithoutAgencyNameQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetRenewalListItemsWithoutAgencyNameQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetRenewalListItemsWithoutAgencyNameDocument, options);
}
export function useGetRenewalListItemsWithoutAgencyNameLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetRenewalListItemsWithoutAgencyNameDocument, options);
}
export function useGetRenewalListItemsWithoutAgencyNameSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetRenewalListItemsWithoutAgencyNameDocument, options);
}
export const GetRenewalListItemsWithoutAgencyDataDocument = gql `
  query GetRenewalListItemsWithoutAgencyData(
    $pagination: PaginationInput
    $sorting: GetRenewalSortInput
    $filter: GetRenewalFilterInput
  ) {
    getRenewalListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...RenewalListItemWithoutAgencyData
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${RenewalListItemWithoutAgencyDataFragmentDoc}
`;
/**
 * __useGetRenewalListItemsWithoutAgencyDataQuery__
 *
 * To run a query within a React component, call `useGetRenewalListItemsWithoutAgencyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenewalListItemsWithoutAgencyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenewalListItemsWithoutAgencyDataQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetRenewalListItemsWithoutAgencyDataQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetRenewalListItemsWithoutAgencyDataDocument, options);
}
export function useGetRenewalListItemsWithoutAgencyDataLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetRenewalListItemsWithoutAgencyDataDocument, options);
}
export function useGetRenewalListItemsWithoutAgencyDataSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetRenewalListItemsWithoutAgencyDataDocument, options);
}
export const MarkRenewalAsPaidDocument = gql `
  mutation MarkRenewalAsPaid($renewalLocator: ID!, $description: String) {
    markRenewalAsPaid(
      renewalLocator: $renewalLocator
      description: $description
    ) {
      ...RenewalWithCheckReceival
    }
  }
  ${RenewalWithCheckReceivalFragmentDoc}
`;
/**
 * __useMarkRenewalAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkRenewalAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkRenewalAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markRenewalAsPaidMutation, { data, loading, error }] = useMarkRenewalAsPaidMutation({
 *   variables: {
 *      renewalLocator: // value for 'renewalLocator'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useMarkRenewalAsPaidMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(MarkRenewalAsPaidDocument, options);
}
export const MarkRenewalAsUnpaidDocument = gql `
  mutation MarkRenewalAsUnpaid($renewalLocator: ID!) {
    markRenewalAsUnpaid(renewalLocator: $renewalLocator) {
      ...RenewalWithCheckReceival
    }
  }
  ${RenewalWithCheckReceivalFragmentDoc}
`;
/**
 * __useMarkRenewalAsUnpaidMutation__
 *
 * To run a mutation, you first call `useMarkRenewalAsUnpaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkRenewalAsUnpaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markRenewalAsUnpaidMutation, { data, loading, error }] = useMarkRenewalAsUnpaidMutation({
 *   variables: {
 *      renewalLocator: // value for 'renewalLocator'
 *   },
 * });
 */
export function useMarkRenewalAsUnpaidMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(MarkRenewalAsUnpaidDocument, options);
}
export const ResendRenewalOfferDocument = gql `
  mutation ResendRenewalOffer($renewalLocator: ID!) {
    resendRenewalOffer(renewalLocator: $renewalLocator) {
      renewalLocator
      status
      updatedDate
    }
  }
`;
/**
 * __useResendRenewalOfferMutation__
 *
 * To run a mutation, you first call `useResendRenewalOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendRenewalOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendRenewalOfferMutation, { data, loading, error }] = useResendRenewalOfferMutation({
 *   variables: {
 *      renewalLocator: // value for 'renewalLocator'
 *   },
 * });
 */
export function useResendRenewalOfferMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(ResendRenewalOfferDocument, options);
}
export const RetryFailedRenewalOperationDocument = gql `
  mutation RetryFailedRenewalOperation($renewalLocator: ID!) {
    retryRenewalFailedOperations(renewalLocator: $renewalLocator) {
      renewalLocator
      status
      updatedDate
    }
  }
`;
/**
 * __useRetryFailedRenewalOperationMutation__
 *
 * To run a mutation, you first call `useRetryFailedRenewalOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryFailedRenewalOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryFailedRenewalOperationMutation, { data, loading, error }] = useRetryFailedRenewalOperationMutation({
 *   variables: {
 *      renewalLocator: // value for 'renewalLocator'
 *   },
 * });
 */
export function useRetryFailedRenewalOperationMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RetryFailedRenewalOperationDocument, options);
}
export const RetryRenewalFailedPaymentDocument = gql `
  mutation RetryRenewalFailedPayment($policyLocator: ID!) {
    retryRenewalFailedPayment(policyLocator: $policyLocator) {
      ...RenewalBase
    }
  }
  ${RenewalBaseFragmentDoc}
`;
/**
 * __useRetryRenewalFailedPaymentMutation__
 *
 * To run a mutation, you first call `useRetryRenewalFailedPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryRenewalFailedPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryRenewalFailedPaymentMutation, { data, loading, error }] = useRetryRenewalFailedPaymentMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useRetryRenewalFailedPaymentMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RetryRenewalFailedPaymentDocument, options);
}
export const RetryRenewalIssuanceDocument = gql `
  mutation RetryRenewalIssuance($renewalLocator: ID!) {
    retryRenewalIssuance(renewalLocator: $renewalLocator) {
      ...RenewalBase
    }
  }
  ${RenewalBaseFragmentDoc}
`;
/**
 * __useRetryRenewalIssuanceMutation__
 *
 * To run a mutation, you first call `useRetryRenewalIssuanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryRenewalIssuanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryRenewalIssuanceMutation, { data, loading, error }] = useRetryRenewalIssuanceMutation({
 *   variables: {
 *      renewalLocator: // value for 'renewalLocator'
 *   },
 * });
 */
export function useRetryRenewalIssuanceMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RetryRenewalIssuanceDocument, options);
}
export const RetryRenewalSendOfferDocument = gql `
  mutation RetryRenewalSendOffer($renewalLocator: ID!) {
    retryRenewalSendOffer(renewalLocator: $renewalLocator) {
      ...RenewalBase
    }
  }
  ${RenewalBaseFragmentDoc}
`;
/**
 * __useRetryRenewalSendOfferMutation__
 *
 * To run a mutation, you first call `useRetryRenewalSendOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryRenewalSendOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryRenewalSendOfferMutation, { data, loading, error }] = useRetryRenewalSendOfferMutation({
 *   variables: {
 *      renewalLocator: // value for 'renewalLocator'
 *   },
 * });
 */
export function useRetryRenewalSendOfferMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RetryRenewalSendOfferDocument, options);
}
export const SearchDocument = gql `
  query Search($query: String!, $status: String) {
    search(query: $query, status: $status) {
      policyLocator
      renewalLocator
      policyholderLocator
      policyholderFirstName
      policyholderLastName
      unitAddress {
        ...AddressFragment
      }
      searchResultType
      createdTimestamp
      status
      quoteStatus
      productTypeName
      applicationInitiation
      isAgentsSignResponsibility
      paperlessDiscount
      startDateAfterUWReview
    }
  }
  ${AddressFragmentFragmentDoc}
`;
/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSearchQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SearchDocument, options);
}
export function useSearchLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SearchDocument, options);
}
export function useSearchSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(SearchDocument, options);
}
export const GetSequoiaListItemsDocument = gql `
  query GetSequoiaListItems(
    $pagination: PaginationInput
    $sorting: GetQuoteSortInput
    $filter: GetQuoteFilterInput
  ) {
    getQuoteListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...SequoiaListItem
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${SequoiaListItemFragmentDoc}
`;
/**
 * __useGetSequoiaListItemsQuery__
 *
 * To run a query within a React component, call `useGetSequoiaListItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequoiaListItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequoiaListItemsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSequoiaListItemsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetSequoiaListItemsDocument, options);
}
export function useGetSequoiaListItemsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetSequoiaListItemsDocument, options);
}
export function useGetSequoiaListItemsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetSequoiaListItemsDocument, options);
}
export const GetSequoiaListItemsWithoutAgencyNameDocument = gql `
  query GetSequoiaListItemsWithoutAgencyName(
    $pagination: PaginationInput
    $sorting: GetQuoteSortInput
    $filter: GetQuoteFilterInput
  ) {
    getQuoteListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...SequoiaListItemWithoutAgencyName
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${SequoiaListItemWithoutAgencyNameFragmentDoc}
`;
/**
 * __useGetSequoiaListItemsWithoutAgencyNameQuery__
 *
 * To run a query within a React component, call `useGetSequoiaListItemsWithoutAgencyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequoiaListItemsWithoutAgencyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequoiaListItemsWithoutAgencyNameQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSequoiaListItemsWithoutAgencyNameQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetSequoiaListItemsWithoutAgencyNameDocument, options);
}
export function useGetSequoiaListItemsWithoutAgencyNameLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetSequoiaListItemsWithoutAgencyNameDocument, options);
}
export function useGetSequoiaListItemsWithoutAgencyNameSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetSequoiaListItemsWithoutAgencyNameDocument, options);
}
export const GetSequoiaListItemsWithoutAgencyDataDocument = gql `
  query GetSequoiaListItemsWithoutAgencyData(
    $pagination: PaginationInput
    $sorting: GetQuoteSortInput
    $filter: GetQuoteFilterInput
  ) {
    getQuoteListItems(
      pagination: $pagination
      sorting: $sorting
      filter: $filter
    ) {
      items {
        ...SequoiaListItemWithoutAgencyData
      }
      pagination {
        from
        size
        total
      }
    }
  }
  ${SequoiaListItemWithoutAgencyDataFragmentDoc}
`;
/**
 * __useGetSequoiaListItemsWithoutAgencyDataQuery__
 *
 * To run a query within a React component, call `useGetSequoiaListItemsWithoutAgencyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequoiaListItemsWithoutAgencyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequoiaListItemsWithoutAgencyDataQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSequoiaListItemsWithoutAgencyDataQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetSequoiaListItemsWithoutAgencyDataDocument, options);
}
export function useGetSequoiaListItemsWithoutAgencyDataLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetSequoiaListItemsWithoutAgencyDataDocument, options);
}
export function useGetSequoiaListItemsWithoutAgencyDataSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetSequoiaListItemsWithoutAgencyDataDocument, options);
}
export const QuerySequoiaStatusesDocument = gql `
  query QuerySequoiaStatuses(
    $source: String!
    $riskId: String
    $nextToken: String
    $pageSize: Int
  ) {
    querySequoiaStatuses(
      source: $source
      riskId: $riskId
      nextToken: $nextToken
      pageSize: $pageSize
    ) {
      items {
        trackingSource
        trackingId
        policyLocator
        policyholderLocator
        status
        statusReason
        underwritingResult {
          decision
          notes
          decisionTimestamp
        }
        updatedTimestamp
      }
      nextToken
    }
  }
`;
/**
 * __useQuerySequoiaStatusesQuery__
 *
 * To run a query within a React component, call `useQuerySequoiaStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuerySequoiaStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuerySequoiaStatusesQuery({
 *   variables: {
 *      source: // value for 'source'
 *      riskId: // value for 'riskId'
 *      nextToken: // value for 'nextToken'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useQuerySequoiaStatusesQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(QuerySequoiaStatusesDocument, options);
}
export function useQuerySequoiaStatusesLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(QuerySequoiaStatusesDocument, options);
}
export function useQuerySequoiaStatusesSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(QuerySequoiaStatusesDocument, options);
}
